import type { TranslationShape } from './types';

export const it: TranslationShape = {
  portfolio: {
    tools: 'Filtri e azioni multiple',
    search: 'Cerca domini',
    expiry: 'Pagato fino al',
    status: 'Stato',
    all: 'Tutti',
    on: 'Attivato',
    off: 'Disattivato',
    expiry_all: 'Qualsiasi data',
    expiry_expired: 'Scaduti',
    expiry_30: 'Prossimi 30 giorni',
    expiry_90: 'Prossimi 90 giorni',
    expiryHint: 'Le date includono i rinnovi pagati. Gli intervalli escludono i domini già scaduti.',
    count: '{{count}} domini su {{total}}',
    reset: 'Reimposta filtri',
    exportFiltered: 'Esporta risultati CSV',
    exportSelected: 'Esporta selezione CSV',
    selected: '{{count}} selezionati',
    selectFiltered: 'Seleziona tutti i risultati',
    clear: 'Cancella selezione',
    select: 'Seleziona',
    selectDomain: 'Seleziona {{domain}}',
    selectionHint: 'Seleziona fino a {{limit}} domini per azione, anche su più pagine. Cambiare i filtri cancella la selezione.',
    renew: 'Aggiungi rinnovi al carrello',
    enable: 'Attiva rinnovo automatico',
    disable: 'Disattiva rinnovo automatico',
    review: 'Verifica domini selezionati',
    renewHint: 'Aggiungi un anno per ogni dominio idoneo al carrello. Verifica i prezzi finali e paga al checkout; questa azione non comporta addebiti.',
    enableHint: 'I rinnovi futuri useranno le impostazioni di pagamento esistenti. Nessun rinnovo viene pagato ora.',
    disableHint: 'Dovrai rinnovare manualmente questi domini per mantenerli. I rinnovi pagati e gli ordini in sospeso restano invariati.',
    priceAtCheckout: 'Prezzo nel carrello',
    confirm: 'Conferma per questi domini',
    results: 'Risultati',
    running: 'Elaborazione dei domini…',
    finished: 'Elaborazione completata. Verifica i risultati qui sotto.',
    retry: 'Riprova domini non riusciti',
    checkout: 'Verifica carrello',
    added: 'Aggiunto al carrello',
    updated: 'Rinnovo automatico aggiornato',
    failed: 'Richiesta non riuscita. Riprova.',
    inactive: 'Non gestito qui; saltato',
    paid: 'Rinnovo già pagato; saltato',
    pending: 'Rinnovo in attesa di pagamento; saltato',
    unchanged: 'Già impostato; saltato',
    inCart: 'Già nel carrello; saltato',
    result_success: 'Riuscito',
    result_failed: 'Non riuscito',
    result_skipped: 'Saltato',
    deleted: 'Eliminato',
    transferred: 'Trasferito altrove',
    unknown: 'Sconosciuto',
    previous: 'Precedente',
    next: 'Successivo',
    page: 'Pagina {{page}} di {{pages}}',
    sort: 'Ordina per',
    sort_name: 'Nome di dominio',
    sort_expiry: 'Scadenza più vicina',
    sort_latest: 'Scadenza più lontana',
  },
  common: {
    search: 'Cerca',
    add: 'Aggiungi',
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    close: 'Chiudi',
    confirm: 'Conferma',
    loading: 'Caricamento...',
    name: 'Nome',
    email: 'E-mail',
    password: 'Password',
    status: 'Stato',
    type: 'Tipo',
    value: 'Valore',
    valueOptional: 'Valore (Facoltativo)',
    address: 'Indirizzo',
    city: 'Città',
    state: 'Cantone',
    country: 'Paese',
    countryOrRegion: 'Paese o regione',
    phone: 'Telefono',
    phoneNumber: 'Numero di telefono',
    code: 'Codice',
    comment: 'Commento',
    settings: 'Impostazioni',
    inUse: 'In uso',
    inCart: 'Nel carrello',
    domain: 'Dominio',
    zipCode: 'CAP',
    yes: 'Sì',
    no: 'No',
    apply: 'Applica',
    verify: 'Verifica',
    individual: 'Privato',
    company: 'Azienda',
    error: 'Errore',
    default: 'Predefinito',
    total: 'Totale',
    items: 'Articoli',
    coupon: 'Coupon',
    remove: 'Rimuovi',
    disable: 'Disabilita',
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
    processing: 'Elaborazione...',
    saveChanges: 'Salva modifiche',
    openMenu: 'Apri menu',
    paid: 'Pagato',
    free: 'Gratuito',
    subtotal: 'Subtotale',
    discount: 'Sconto',
    amountDue: 'Importo dovuto',
    product: 'Prodotto',
    quantity: 'Quantità',
    totalCost: 'Costo totale',
    actions: 'Azioni',
    pay: 'Paga',
    host: 'Host',
    destination: 'Destinazione',
    hostname: 'Nome host',
    created: 'Creato',
    notFoundDescription: 'La pagina che stai cercando deve ancora essere programmata.',
    goToHome: 'Vai alla home',
    notAuthenticated: 'Non autenticato',
    toggleTheme: 'Cambia tema',
    themeLight: 'Chiaro',
    themeDark: 'Scuro',
    themeSystem: 'Sistema',
    allSystemsNormal: 'Tutti i sistemi normali',
    systemNotNormal: 'Sistema non funzionante',
    previous: 'Precedente',
    next: 'Successivo',
    page: 'Pagina',
    rowsPerPage: 'Righe per pagina',
    selectSection: 'Seleziona una sezione',
    noResults: 'Nessun risultato.',
    searchCountry: 'Cerca paese...',
    noCountryFound: 'Nessun paese trovato.',
    searchState: 'Cerca cantone...',
    selectCountryFirst: 'Seleziona prima un paese',
    price: 'Prezzo',
    faq: 'Domande frequenti',
    perMonth: '/ mese',
    perYear: '/ anno',
    overview: 'Panoramica',
    beta: 'Beta',
    expired: 'Scaduto',
    expiringSoon: 'In scadenza',
  },
  nav: {
    domains: 'Domini',
    registration: 'Registrazione',
    transfer: 'Trasferimento',
    tldPrices: 'Prezzi TLD',
    hosting: 'Hosting',
    websiteHosting: 'Hosting web',
    services: 'Servizi',
    docs: 'Docs',
    whoisLookup: 'Ricerca Whois',
    whois: 'Whois',
    toggleMenu: 'Attiva/disattiva menu',
    legal: 'Legale',
    termsOfService: 'Termini di servizio',
    domainRegistrationAgreement: 'Contratto di registrazione dominio',
    websiteHostingAgreement: 'Contratto di hosting web',
    dataProcessingAgreement: 'Contratto di trattamento dati',
    privacyPolicy: 'Informativa sulla privacy',
    registrationDescription: 'Acquista un nuovo dominio da YourWebTech.',
    transferDescription: 'Trasferisci il tuo dominio a YourWebTech.',
    tldPricesDescription: 'Controlla i prezzi dei TLD.',
    docsDescription: 'Leggi la documentazione del prodotto e le guide di supporto.',
  },
  auth: {
    login: 'Accedi',
    signIn: 'Accedi',
    signUp: 'Registrati',
    createAccount: 'Crea account',
    createAnAccount: 'Crea un account',
    enterEmailToCreate: 'Inserisci il tuo indirizzo e-mail qui sotto per creare il tuo account',
    continueWithGoogle: 'Continua con Google',
    continueWithGitHub: 'Continua con GitHub',
    alreadyHaveAccount: 'Hai già un account?',
    dontHaveAccount: 'Non hai un account?',
    resetPassword: 'Reimposta password',
    emailAddress: 'Indirizzo e-mail',
    orYouCanAlso: 'Oppure puoi anche',
    forgotPassword: 'Password dimenticata?',
    forgotPasswordTitle: 'Password dimenticata',
    forgotPasswordDescription: 'Inserisci il tuo indirizzo e-mail e ti invieremo un link per scegliere una nuova password.',
    invalidCredentials: 'Credenziali non valide',
    signInUnavailable: 'Al momento non è possibile accedere. Riprova tra poco.',
    accountCreated: 'Account creato. Abbiamo inviato un link di conferma a {{email}}.',
    loggedOut: 'Disconnessione effettuata con successo',
    enterEmailToLogin: 'Inserisci il tuo indirizzo e-mail qui sotto per accedere',
    twoFactorAuth: 'Autenticazione a due fattori',
    twoFactorDescription: 'Inserisci il codice a 6 cifre dalla tua app di autenticazione per continuare.',
    authenticationCode: 'Codice di autenticazione',
    twoFactorTitle: 'Autenticazione a due fattori (TOTP)',
    twoFactorProtect: "Proteggi il tuo account richiedendo un codice monouso da un'app di autenticazione quando accedi.",
    twoFactorEnabled: 'Ti verrà chiesto un codice dalla tua app di autenticazione quando accedi.',
    twoFactorEnableHint: 'Abilita TOTP per generare un segreto per la tua app di autenticazione (es. Google Authenticator, 1Password, Authy).',
    twoFactorScanQr: 'Scansiona questo codice QR nella tua app di autenticazione',
    twoFactorSecretKey: 'Chiave segreta (inserisci manualmente se necessario)',
    twoFactorVerificationCode: 'Codice di verifica dalla tua app di autenticazione',
    twoFactorSixDigitCode: 'Codice a 6 cifre',
    enable2fa: 'Abilita 2FA',
    disable2fa: 'Disabilita 2FA',
    verifyAndEnable: 'Verifica e abilita',
    disable2faTitle: "Disabilitare l'autenticazione a due fattori?",
    disable2faDescription: 'Non ti verrà più chiesto un codice di verifica quando accedi. Questo riduce la sicurezza del tuo account.',
    // Auth store toasts
    mfaSessionExpired: "Sessione MFA scaduta. Effettua nuovamente l'accesso.",
    noMfaFactor: 'Nessun fattore MFA disponibile.',
    mfaSignInError: "Errore durante il completamento dell'accesso 2FA.",
    mustBeSignedIn2fa: "Devi aver effettuato l'accesso per abilitare la 2FA.",
    failedStart2fa: 'Impossibile avviare la registrazione 2FA: ',
    totpSecretNotFound: 'Segreto TOTP non trovato. Riavvia la registrazione.',
    twoFactorEnabledToast: 'Autenticazione a due fattori abilitata.',
    failedEnable2fa: 'Impossibile abilitare la 2FA: ',
    mustBeSignedInDisable2fa: "Devi aver effettuato l'accesso per disabilitare la 2FA.",
    noTotpEnabled: 'Nessun fattore TOTP attualmente abilitato.',
    twoFactorDisabled: 'Autenticazione a due fattori disabilitata.',
    failedDisable2fa: 'Impossibile disabilitare la 2FA: ',
    errorSigningUp: 'Non è stato possibile creare il tuo account. Riprova.',
    exitImpersonation: "Esci dall'impersonificazione",
    showPassword: 'Mostra password',
    hidePassword: 'Nascondi password',
    passwordRule: {
      minLength: 'Almeno 8 caratteri',
      uppercase: 'Una lettera maiuscola',
      lowercase: 'Una lettera minuscola',
      number: 'Un numero',
    },
    invalidEmail: 'Inserisci un indirizzo e-mail valido',
    passwordRequired: 'Inserisci la tua password',
    passwordRequirementsNotMet: 'La password non soddisfa ancora tutti i requisiti',
    tooManyAttempts: 'Troppi tentativi. Attendi qualche minuto o reimposta la password.',
    wrongEmailOrPassword: "L'indirizzo e-mail o la password non sono corretti.",
    noAccountYet: 'Nuovo qui?',
    createAccountWithEmail: 'Crea un account con {{email}}',
    emailAlreadyRegistered: 'Esiste già un account con questo indirizzo e-mail.',
    signInInstead: 'Accedi',
    errorSendingResetLink: "Non è stato possibile inviare l'e-mail. Riprova tra poco.",
    sendResetLink: 'Invia link',
    checkYourInbox: 'Controlla la tua casella di posta',
    resetLinkSent: 'Se esiste un account per {{email}}, gli abbiamo inviato un link per scegliere una nuova password.',
    resetLinkHelp: "Il link è valido per 1 ora. Non hai ricevuto nulla? Controlla la cartella spam o verifica che sia l'indirizzo con cui ti sei registrato.",
    useDifferentEmail: 'Usa un altro indirizzo e-mail',
    backToSignIn: "Torna all'accesso",
    emailConfirmed: 'Indirizzo e-mail confermato',
    emailConfirmedDescription: 'Grazie. Useremo questo indirizzo per le tue fatture e gli avvisi sui domini.',
    goToAccount: 'Vai al tuo account',
    chooseNewPassword: 'Scegli una nuova password',
    chooseNewPasswordFor: 'Per {{email}}',
    newPassword: 'Nuova password',
    saveAndSignIn: 'Salva e accedi',
    linkInvalid: 'Questo link non è più valido',
    verifyLinkInvalidDescription: 'Potrebbe essere scaduto o già stato usato. Se il tuo indirizzo non è ancora confermato, puoi richiedere un nuovo link dal tuo account.',
    resetLinkInvalidDescription: 'I link di reimpostazione funzionano una sola volta e per 1 ora. Richiedine uno nuovo per scegliere la password.',
    requestNewLink: 'Richiedi un nuovo link',
    confirmEmailNotice: 'Conferma il tuo indirizzo e-mail {{email}} con il link che ti abbiamo inviato, così le nostre fatture e gli avvisi sui domini ti raggiungeranno.',
    verificationEmailResent: 'Abbiamo inviato un nuovo link a {{email}}.',
    resendVerificationEmail: 'Invia di nuovo il link',
    errorSendingVerificationEmail: "Non è stato possibile inviare l'e-mail. Riprova più tardi.",
  },
  domain: {
    batch: {
      single: 'Un solo dominio',
      title: 'Trasferimento multiplo',
      description: 'Carica o incolla fino a {{count}} domini .ch/.li con i relativi codici di trasferimento.',
      nameservers: 'I nameserver attuali restano invariati. Se il vecchio fornitore gestisce anche il DNS, verifica che il servizio continui dopo il trasferimento.',
      upload: 'Carica CSV',
      paste: 'Incolla domini e codici di trasferimento',
      format:
        'Due colonne: domain, auth_code. Sono supportati virgole, punti e virgola e tabulazioni; l’intestazione è facoltativa. Massimo 64 KB. Usa la notazione xn-- per i nomi internazionalizzati.',
      preview: 'Anteprima dei domini',
      review: 'Controlla {{count}} domini. Correggi o rimuovi le righe non valide, poi verifica se il trasferimento è possibile.',
      pricing: 'Prezzo per dominio',
      transferPrice: 'Trasferimento:',
      renewalPrice: 'Rinnovo / anno:',
      checkoutPrice: 'Prezzo confermato al checkout',
      check: 'Verifica domini ({{count}})',
      add: 'Aggiungi domini pronti ({{count}})',
      startOver: 'Importa un altro elenco',
      cartNotice:
        'Vengono aggiunti solo i domini pronti. Controlla i prezzi finali al checkout prima di confermare il trasferimento. Rimuovere una riga dall’anteprima non rimuove un dominio già nel carrello.',
      checkout: 'Continua al carrello',
      working: 'Elaborazione dei domini. Lascia aperta questa pagina.',
      remove: 'Rimuovi',
      removeRow: 'Rimuovi riga {{count}}',
      domainRow: 'Dominio nella riga {{count}}',
      codeRow: 'Codice di trasferimento nella riga {{count}}',
      empty: 'Inserisci almeno un dominio e il relativo codice di trasferimento.',
      tooLarge: 'L’input supera 64 KB. Dividilo in file più piccoli.',
      tooMany: 'Un gruppo può contenere al massimo {{count}} domini. Dividi l’elenco.',
      malformed: 'Il file CSV contiene virgolette non valide. Controlla i campi e riprova.',
      columns: 'Ogni riga deve contenere esattamente due colonne: domain e auth_code.',
      readFailed: 'Impossibile leggere il file. Riprova o incolla il contenuto.',
      invalidDomain: 'Inserisci un dominio .ch o .li valido, senza URL o sottodominio.',
      missingCode: 'Inserisci un codice di trasferimento.',
      invalidCode: 'Il codice contiene un’interruzione di riga, un carattere di controllo o più di 1024 caratteri.',
      duplicate: 'Questo dominio compare più volte. Rimuovi la riga duplicata.',
      inCart: 'Già nel carrello.',
      unchecked: 'Non ancora verificato',
      checking: 'Verifica in corso…',
      ready: 'Pronto da aggiungere',
      unavailable: 'Trasferimento non disponibile. Verifica il codice e lo stato presso il registrar attuale.',
      checkFailed: 'Verifica non riuscita. Riprova per questo dominio.',
      adding: 'Aggiunta al carrello…',
      added: 'Aggiunto al carrello',
      addFailed: 'Impossibile aggiungere al carrello. Riprova per questa riga.',
    },
    domain: 'Dominio',
    domainName: 'Nome del dominio',
    creationDate: 'Data di creazione',
    expirationDate: 'Data di scadenza',
    autoRenewal: 'Rinnovo automatico',
    autoRenew: 'Rinnovo automatico',
    registrar: 'Registrar',
    nameservers: 'Nameserver',
    nameserversAndDns: 'Nameserver e record DNS',
    nameserversTitle: 'Nameserver',
    nameserversDescription:
      'Per impostazione predefinita, utilizziamo i nameserver YWT per il tuo dominio. Puoi cambiarli con i tuoi nameserver. In tal caso, i record DNS saranno gestiti dai tuoi nameserver.',
    nameserversChanged: 'Nameserver modificato con successo',
    urlForwarding: 'Reindirizzamento URL',
    rootHint: 'Usa @ per la radice.',
    addToCart: 'Aggiungi al carrello',
    tooLong: 'Dominio troppo lungo!',
    tooShort: 'Dominio troppo corto!',
    port: 'Porta',
    priority: 'Priorità',
    target: 'Destinazione',
    ttl: 'TTL',
    weight: 'Peso',
    manageDomain: 'Gestisci il tuo dominio',
    whoisPrivacy: 'Privacy Whois',
    whoisPrivacyEnabled: 'La privacy Whois è abilitata per impostazione predefinita. Le tue informazioni di contatto non sono visibili pubblicamente.',
    dnssec: 'DNSSEC',
    dnssecFull: 'Sicurezza del Domain Name System (DNSSEC)',
    dnssecUpdated: 'DNSSEC aggiornato',
    dnssecRecordAdded: 'Record DNSSEC aggiunto',
    dnssecRecordRemoved: 'Record DNSSEC rimosso',
    acmeKeysTitle: 'Automazione dei certificati (ACME)',
    acmeKeysDescription:
      "Chiavi per certbot, acme.sh o lego, così possono rinnovare i certificati Let's Encrypt o ZeroSSL di questo dominio, wildcard compresi, con la challenge DNS-01. Una chiave può solo aggiungere e rimuovere record TXT con nomi _acme-challenge di questo dominio.",
    acmeKeysEmpty: 'Ancora nessuna chiave.',
    acmeKeyCreate: 'Crea chiave',
    acmeKeyCreateHint: 'La chiave può solo aggiungere e rimuovere record TXT con nomi _acme-challenge di questo dominio. Il suo segreto viene mostrato una sola volta, subito dopo la creazione.',
    acmeKeyLabel: 'Etichetta',
    acmeKeyLabelPlaceholder: 'Per esempio: server web (facoltativo)',
    acmeKeyUnnamed: 'Senza etichetta',
    acmeKeyName: 'Nome della chiave',
    acmeKeyCreated: 'Creata il',
    acmeKeyRevoke: 'Revoca',
    acmeKeyRevokeTitle: 'Revocare questa chiave?',
    acmeKeyRevokeConfirm: 'Gli strumenti per i certificati che la usano non possono più modificare il DNS: il loro prossimo rinnovo fallisce finché non ricevono una nuova chiave.',
    acmeKeyLimit: "Un dominio può avere fino a {{count}} chiavi. Revocane una per crearne un'altra.",
    acmeKeyDocs: 'Guida alla configurazione',
    acmeKeyCreatedTitle: 'Chiave creata',
    acmeKeySecretOnce: 'Copia il segreto ora: viene mostrato solo questa volta. Se lo perdi, revoca la chiave e creane una nuova.',
    acmeKeyServer: 'Server',
    acmeKeyAlgorithm: 'Algoritmo',
    acmeKeySecret: 'Segreto',
    acmeKeySaveFile: 'Salva questo come {{path}}, leggibile solo da root:',
    acmeKeyThenRun: 'Poi esegui:',
    acmeKeyRun: 'Esegui:',
    acmeKeyDone: 'Fatto',
    acmeKeyCopy: 'Copia',
    acmeKeyCopied: 'Copiato',
    acmeKeyCopyFailed: 'Impossibile copiare. Seleziona il testo e copialo a mano.',
    acmeKeyCnameConflict:
      '_acme-challenge è un CNAME (verso {{target}}), quindi queste chiavi non possono scriverci i record della challenge. Elimina quel CNAME nei record DNS qui sopra per usarle con questo dominio.',
    dnssecYwtHint: 'Stai utilizzando i nameserver YWT. Puoi facilmente abilitare o disabilitare DNSSEC con un clic.',
    dnssecAdvanced: 'Gestione avanzata DNSSEC',
    dnssecAdvancedHint: 'Gestisci qui i record DS (DNSSEC) del tuo dominio. Sai cosa stai facendo!',
    dnssecNoRecords: 'Nessun record DNSSEC.',
    dnssecAddRecord: 'Aggiungi record DNSSEC',
    dnssecProvideDs: 'Fornisci i valori del record DS. I dati della chiave sono facoltativi.',
    dnssecKeyTag: 'Tag chiave',
    dnssecAlgorithm: 'Algoritmo',
    dnssecDigestType: 'Tipo di digest',
    dnssecDigest: 'Digest',
    dnssecHexDigest: 'Digest esadecimale (max 96 caratteri)',
    dnssecIncludeKeyData: 'Includi dati della chiave',
    dnssecOptional: '[facoltativo]',
    dnssecFlags: 'Flag',
    dnssecProtocol: 'Protocollo',
    dnssecKeyAlgorithm: 'Algoritmo della chiave',
    dnssecPublicKey: 'Chiave pubblica',
    dnssecBase64Key: 'Chiave Base64',
    dnssecFixedProtocol: 'Fisso: 3',
    dnssecKeyDataRequired: 'Obbligatorio quando i dati della chiave sono inclusi',
    dnssecFillRequired: 'Compila keyTag, algoritmo, digestType e digest',
    dnssecKeyTagRange: 'keyTag deve essere compreso tra 0 e 65535',
    dnssecDigestMax: 'Il digest deve contenere al massimo 96 caratteri',
    dnssecKeyDataFieldsRequired: 'Flag, protocollo, algoritmo della chiave e chiave pubblica sono obbligatori quando si includono i dati della chiave',
    dnssecKeyTagLabel: 'Tag chiave:',
    dnssecAlgLabel: 'Alg.:',
    dnssecDigestTypeLabel: 'Tipo digest:',
    dnssecDigestLabel: 'Digest:',
    dnssecSelect: 'Seleziona',
    dnssecAllowedAlgorithms: 'Consentiti: 8, 10, 13, 14, 15, 16',
    dnssecAllowedDigestTypes: 'Consentiti: 2 o 4',
    searchTitle: 'Cerca un dominio .ch/.li',
    searchDescription: 'Registrare un dominio non è mai stato così semplice, chiaro e veloce.',
    searchPlaceholder: 'Trova qui il tuo dominio ideale...',
    searchInfoTitle: 'Informazioni sui domini .ch e .li',
    searchInfoIntro:
      'YourWebTech è un registrar svizzero accreditato (SWITCH). Cerca qui sopra un qualsiasi nome .ch o .li, verifica la disponibilità e registralo in pochi minuti — DNSSEC, controllo DNS completo e privacy Whois sono inclusi con ogni dominio.',
    faqRegEligibilityQ: 'Chi può registrare un dominio .ch o .li?',
    faqRegEligibilityA: 'I domini .ch e .li sono aperti a tutti, in tutto il mondo — non è richiesta alcuna residenza o presenza locale. Ti bastano dei recapiti validi.',
    faqRegSpeedQ: 'Quanto tempo richiede la registrazione?',
    faqRegSpeedA:
      "Le registrazioni passano attraverso il registro svizzero SWITCH e di solito si completano in pochi minuti. Il tuo dominio e il DNS sono pronti per essere gestiti non appena l'operazione termina.",
    faqRegDnssecQ: 'DNSSEC e la gestione DNS sono inclusi?',
    faqRegDnssecA: 'Sì. Ogni dominio include DNSSEC gratuito, i nostri name server svizzeri e un semplice editor per record A, AAAA, CNAME, MX, TXT e altri — senza costi aggiuntivi.',
    faqRegTransferInQ: 'Posso trasferire un dominio che possiedo già?',
    faqRegTransferInA: 'Sì — puoi trasferire gratuitamente i tuoi domini .ch e .li esistenti a YourWebTech. Inizia dalla pagina di trasferimento con il codice di autorizzazione del tuo dominio.',
    transferTitle: 'Trasferisci un dominio .ch/.li',
    transferDescription: 'Stanco di aspettare una settimana? A differenza di altri registrar, offriamo trasferimenti di dominio <bold>istantanei</bold>.',
    transferNotAvailable: 'Il dominio non è disponibile per il trasferimento',
    perYear: '/ anno',
    renewsAt: 'si rinnova a',
    registration: 'Registrazione',
    renewal: 'Rinnovo',
    renewalDescription: 'Gestisci il rinnovo automatico e crea un ordine di rinnovo se necessario.',
    autoRenewalLabel: 'Rinnovo automatico',
    autoRenewalHint: "Ricevi un'e-mail di promemoria con link di pagamento 30 giorni prima della scadenza.",
    autoRenewalEnabled: 'Rinnovo automatico abilitato',
    autoRenewalDisabled: 'Rinnovo automatico disabilitato',
    autoRenewalInfo:
      'Se abilitato, riceverai un addebito automatico o un promemoria via e-mail 30 giorni prima della scadenza. Altrimenti, il dominio rischia di scadere e dovrai rinnovarlo manualmente.',
    renewNow: 'Rinnova ora',
    renewNowHint: 'Crea un ordine di rinnovo immediatamente e paga subito.',
    renewalAddedToCart: 'Rinnovo aggiunto al carrello',
    renewalOrderCreated: 'Ordine di rinnovo pronto',
    renewalFeePaidTill: 'Tariffa di rinnovo pagata fino al {{date}}',
    goToCart: 'Vai al carrello',
    noDomains: 'Nessun dominio',
    noDomainsDescription: 'Non hai ancora registrato alcun dominio.',
    copyNameservers: 'Copia nameserver',
    ywtNs: 'NS YourWebTech',
    ywtNsTooltip: 'YWT utilizza i seguenti server DNS per questo dominio: ',
    expires: 'Scade:',
    dnsRecords: 'Record DNS',
    dnsRecordsDescription: 'I record DNS puntano ai servizi utilizzati dal tuo dominio, come il reindirizzamento del dominio o la configurazione di un servizio e-mail.',
    dnsOwnNameservers: 'Stai utilizzando i tuoi nameserver.',
    dnsOwnNameserversHint: 'Puoi gestire i tuoi record DNS direttamente presso il tuo provider di nameserver.',
    dnsFailedToAdd: 'Impossibile aggiungere il record DNS',
    dnsEditRecord: 'Modifica record {{type}}',
    dnsEditRecordHint: 'Apporta le modifiche al record qui. Fai clic su Salva quando hai finito.',
    dnsDeleteRecord: 'Elimina record',
    dnsDeleteConfirm: 'Stai per rimuovere il seguente record. Sei sicuro di voler continuare?',
    dnsAuto: 'Auto',
    dnsAutoTooltip: 'I record DNS sono gestiti automaticamente',
    removeDomain: 'Rimuovi dominio',
    removeDomainDescription: 'Rimuovi il dominio dal tuo account.',
    removeDomainConfirm: 'Sei sicuro di voler rimuovere il dominio <strong>{{domain}}</strong> dal tuo account?',
    removeDomainIrreversible: 'Questa azione è irreversibile e il dominio verrà eliminato dal tuo account.',
    removeDomainSuccess: 'Dominio rimosso dal tuo account.',
    yesRemoveIt: 'Sì, rimuovilo',
    dangerZone: 'Zona pericolosa',
    dangerZoneDescription: 'Le funzionalità di cui hai raramente bisogno.',
    transferOut: 'Trasferimento in uscita',
    transferOutHint: 'Hai semplicemente cliccato il pulsante sbagliato, vero? Sapevi che non devi trasferire il tuo dominio per ospitarlo altrove?',
    transferOutConfirm: 'Ma se sei sicuro di voler trasferire <strong>{{domain}}</strong>, ti faciliteremo il processo generando un nuovo codice di autorizzazione e inviandotelo via e-mail.',
    transferOutSuccess: 'Ti abbiamo inviato il codice di autorizzazione via e-mail.',
    transferOutNotAllowed: 'Trasferimento in uscita non consentito.',
    yesMadeUpMind: 'Sì, ho deciso',
    transferProhibitedInfo: 'Il dominio attualmente non è trasferibile. Se hai appena trasferito il dominio da noi, è normale.',
    transferredAwayBadge: 'Trasferito altrove',
    transferredAwayTitle: 'Questo dominio è stato trasferito a un altro registrar.',
    transferredAwayDescription: 'Non è più gestito da YourWebTech ed è mostrato qui solo a titolo informativo. Puoi rimuoverlo dal tuo account in qualsiasi momento.',
    deletedTitle: 'Questo dominio è stato eliminato',
    deletedRestorable: 'È scaduto ed è stato eliminato presso il registro, quindi sito web, e-mail e altri servizi non funzionano più. Puoi ripristinarlo fino al {{date}}.',
    restoreIncludesYear: "Il prezzo include l'anno successivo.",
    restoreKeepsDns: 'I suoi record DNS vengono mantenuti. Siti web e inoltri URL che lo usavano vanno aggiunti di nuovo dopo il ripristino.',
    restoreAfterDeadline: 'Dopo il {{date}} chiunque può registrarlo.',
    restoreDomainFor: 'Ripristina per {{price}}',
    deletedNoLongerRestorable: 'È scaduto, è stato eliminato presso il registro e non può più essere ripristinato. Appena il registro lo rilascia, chiunque può registrarlo di nuovo.',
    deletedRestoreBySupport: 'È scaduto ed è stato eliminato presso il registro. Per ripristinarlo, contatta il nostro supporto.',
    restorableUntilBadge: 'Eliminato · ripristinabile fino al {{date}}',
    deletedBadge: 'Eliminato',
    oneYear: '1 anno',
    oneYearTooltip: 'Il registro consente la registrazione per un massimo di un anno. Ma non preoccuparti, imposteremo il rinnovo automatico per ogni dominio finché non lo annulli.',
    // URL Forwarding
    urlForwardingTitle: 'Reindirizzamento URL',
    urlForwardingDescription: 'Reindirizza il tuo dominio (e sottdomini opzionali) verso un altro sito web.',
    howForwardingWorks: 'Come funziona il reindirizzamento',
    howForwardingWorksDescription:
      'Crea una o più regole di reindirizzamento qui sotto. Lascia il nome host vuoto per reindirizzare il dominio principale. Abilita il reindirizzamento wildcard per reindirizzare anche i sottohost. Il reindirizzamento diventa effettivo normalmente in pochi minuti.',
    editRule: 'Modifica regola',
    addNew: 'Aggiungi nuovo',
    hostnameLabel: 'Nome host',
    blankForRoot: '(vuoto per la radice)',
    hostnameExample: 'Esempio: "www" reindirizza {{hostname}}',
    forwardTrafficTo: 'Reindirizza il traffico verso',
    invalidUrlHint: 'Input non valido. Deve iniziare con http o https',
    wildcardForwarding: 'Reindirizzamento wildcard',
    wildcardForwardingHint: 'Reindirizza anche i sottohost di questo nome host',
    wildcardForwardingInfo:
      'Se abilitato, questa regola reindirizza anche i sottohost. Esempio: nome host "abc" + wildcard reindirizza sia "abc.{{host}}" che "*.abc.{{host}}" (es. def.abc.example.com").',
    includePathLabel: 'Includi percorso',
    includePathHint: 'Aggiungi percorso + query alla destinazione',
    includePathInfo: 'Se abilitato, il percorso + query richiesto (es. "/docs?x=1") verrà aggiunto all\'URL di destinazione.',
    advancedLabel: 'Avanzate',
    advancedHint: 'Codice di stato (predefinito 307)',
    advancedInfo: 'Scegli il codice di stato del reindirizzamento. Il valore predefinito è 307 (temporaneo) per preservare metodo e corpo.',
    redirectType: 'Tipo di reindirizzamento',
    selectStatusCode: 'Seleziona codice di stato',
    updateRule: 'Aggiorna regola',
    addRule: 'Aggiungi regola',
    currentForwards: 'Reindirizzamenti attuali',
    noForwards: 'Nessun reindirizzamento configurato.',
    includePath: 'Includi percorso',
    noPath: 'Nessun percorso',
    checking: 'Verifica in corso...',
    dnsOk: 'OK',
    dnsOkTooltip: 'Il DNS punta correttamente ai nostri server',
    dnsMissing: 'Mancante',
    dnsConfigRequired: 'Configurazione DNS necessaria',
    dnsAutoAdded: 'Questi record dovrebbero essere aggiunti automaticamente. Fai clic su "Ricontrolla" se non appaiono.',
    dnsAddRecords: 'Aggiungi i seguenti record DNS tramite il tuo provider DNS:',
    recheckDns: 'Ricontrolla DNS',
    sslActive: 'Attivo',
    sslActiveTooltip: 'Il certificato SSL è attivo',
    sslWaitingForDns: 'In attesa del DNS',
    sslWaitingForDnsTooltip: 'HTTPS si attiva automaticamente quando il DNS punta a YourWebTech',
    sslIssuing: 'Emissione in corso',
    sslIssuingTooltip: 'Il certificato SSL è in fase di emissione, di solito entro un minuto',
    editRuleTooltip: 'Modifica regola',
    deleteRuleTooltip: 'Elimina regola',
    permanentRedirectWarning: 'Avviso reindirizzamento permanente',
    permanentRedirectBody: 'Stai per creare un <strong>reindirizzamento permanente ({{code}})</strong>.',
    permanentRedirectCacheWarning:
      'I browser e i motori di ricerca memorizzano nella cache i reindirizzamenti permanenti in modo aggressivo. Se commetti un errore, gli utenti potrebbero continuare a essere reindirizzati anche dopo aver rimosso la regola.',
    permanentRedirectSuggestion: 'Usa un reindirizzamento temporaneo (302 o 307) se stai testando o potresti dover modificare in seguito.',
    permanentRedirectConfirm: 'Ho capito, crea reindirizzamento permanente',
    forwardAdded: 'Reindirizzamento aggiunto',
    forwardUpdated: 'Reindirizzamento aggiornato',
    forwardingRemoved: 'Reindirizzamento rimosso',
    forwardRemoved: 'Reindirizzamento rimosso',
    ruleEnabled: 'Regola abilitata',
    ruleDisabled: 'Regola disabilitata',
    transferDomainPlaceholder: 'Il dominio da trasferire',
    authCodePlaceholder: 'Il codice di autorizzazione',
    // Nameservers
    useYwtNameservers: 'Usa i nameserver YWT',
    useYwtNameserversDescription: 'Usa i nostri nameserver predefiniti per gestire automaticamente i tuoi record DNS.',
    defaultNameservers: 'Nameserver predefiniti:',
    customNameservers: 'Nameserver personalizzati:',
    noneConfigured: 'Nessuno configurato',
    nameserver1: 'Nameserver 1',
    nameserver2: 'Nameserver 2',
    nameserver3Optional: 'Nameserver 3 (Facoltativo)',
    nameserver4Optional: 'Nameserver 4 (Facoltativo)',
    dnsCommentPlaceholder: 'Un commento che spiega a cosa serve questo record DNS.',
    dnsCommentDescription: 'Questo è solo per il tuo riferimento e non avrà alcun impatto sul tuo record DNS.',
    // Domain pricing page
    pricingTitle: 'Prezzi dei domini',
    pricingSubtitle: 'Il rinnovo costa quanto la registrazione e il trasferimento è gratuito. Nessun primo anno economico che poi diventa caro.',
    pricingHeadline: "{{price}} all'anno. Ogni anno.",
    compareTitle: 'Quanto costa un dominio .ch in {{years}} anni',
    compareSubtitle: 'Molti registrar scontano il primo anno e lo recuperano a ogni rinnovo.',
    compareRegistrar: 'Registrar',
    compareFirstYear: 'Primo anno',
    compareRenewal: 'Ogni rinnovo',
    compareTotal: '{{years}} anni',
    compareMoreThanUs: 'Più caro di YWT',
    compareFootnote: 'Prezzi IVA svizzera inclusa, come pubblicati sul sito di ciascun registrar il {{date}}. Totale = primo anno + un rinnovo per ogni anno successivo.',
    domainTld: 'TLD del dominio',
    vatNote: "*I prezzi includono l'8.1% di IVA svizzera per i clienti in Svizzera.",
    findYourDomain: 'Trova il tuo dominio',
    whatsIncludedDomain: 'Cosa è incluso con ogni dominio',
    ywtDnsServers: 'Server DNS YWT',
    dnssecSupportFeature: 'Supporto DNSSEC',
    urlForwardingFeature: 'Reindirizzamento URL',
    easyDnsManagement: 'Gestione DNS semplice',
    greatUx: 'Ottima esperienza utente',
    freeTransfers: 'Trasferimenti gratuiti',
    emailSupport: 'Supporto via e-mail',
    noHiddenFees: 'Nessun costo nascosto',
    faqTrustQ: 'Posso fidarmi di voi?',
    faqTrustA:
      'Siamo un registrar accreditato riconosciuto dal registro ufficiale svizzero \u2014 <switch>SWITCH</switch>. Questo dovrebbe dimostrare che prendiamo sul serio la nostra attività e i nostri clienti.',
    faqVatQ: "Come viene gestita l'IVA?",
    faqVatA:
      "Il prezzo visualizzato è lo stesso per tutti. Per i clienti svizzeri, l'8.1% di IVA è incluso nel prezzo (indicato nelle fatture). I clienti al di fuori della Svizzera pagano lo stesso importo, ma l'IVA svizzera non si applica.",
    faqHiddenFeesQ: 'Ci sono costi nascosti?',
    faqHiddenFeesA: 'No. Il nostro piano tariffario è trasparente. Quello che vedi è quello che paghi. Non addebitiamo costi aggiuntivi di attivazione, di servizio o di altro tipo.',
    faqRenewalPriceQ: 'Il prezzo di rinnovo è lo stesso del prezzo di registrazione?',
    faqRenewalPriceA:
      'Sì, a differenza di molti altri registrar che attirano con una registrazione economica il primo anno per poi triplicare il prezzo di rinnovo, noi applichiamo lo stesso prezzo per il rinnovo e per la registrazione.',
    faqTransfersQ: 'Non addebitate nulla per i trasferimenti di dominio?',
    faqTransfersA: 'Esatto, non addebitiamo nulla per i trasferimenti di dominio. Accogliamo con piacere tutti i titolari di dominio che desiderano unirsi a noi e usufruire dei nostri servizi.',
    faqPaymentMethodsQ: 'Quali metodi di pagamento accettate?',
    faqPaymentMethodsA: 'Accettiamo tutte le principali carte di credito (Visa, Mastercard, American Express). Altri metodi di pagamento potranno essere valutati e aggiunti in futuro.',
    faqPriceChangesQ: 'I prezzi possono cambiare?',
    faqPriceChangesA:
      "Molti fattori possono influenzare il prezzo di un dominio. Ad esempio, <switch>SWITCH</switch> può modificare i costi all'ingrosso, i costi dell'infrastruttura possono variare, ecc. Ma cerchiamo di mantenere i prezzi il più accessibili possibile.",
    faqRefundsQ: 'Posso richiedere un rimborso?',
    faqRefundsA:
      'Se un dominio è stato registrato o rinnovato con successo, non è possibile richiedere un rimborso poiché è già stato elaborato con <switch>SWITCH</switch>. Se la registrazione, il trasferimento o il rinnovo del dominio non sono stati completati, contatta il supporto e ti aiuteremo.',
    faqMoreThanOneYearQ: 'Posso registrare un dominio per più di un anno?',
    faqMoreThanOneYearA: 'Tecnicamente non è possibile registrare domini .ch/.li per più di un anno. Il registro <switch>SWITCH</switch> consente la registrazione per un massimo di un anno.',
    expirationRenewalTooltip: 'La data di scadenza attuale del dominio è {{registryDate}} nel registro. Ma verrà rinnovato automaticamente fino al {{renewalDate}}.',
  },
  checkout: {
    paymentDetail: 'Dettagli di pagamento',
    enterBillingAddress: 'Inserisci indirizzo di fatturazione',
    editBillingAddress: 'Modifica indirizzo di fatturazione',
    payNow: 'Paga ora',
    payOrder: 'Paga ordine',
    noPay: 'Non ho bisogno di pagare',
    paymentSecureForm: 'Utilizza il modulo sicuro qui sotto per completare il pagamento.',
    paymentFormUnavailable: 'Modulo di pagamento non disponibile',
    paymentFormUnavailableDescription: 'Stripe non è stato caricato. Controlla eventuali blocchi dei contenuti o la connessione di rete, quindi aggiorna questa pagina.',
    paymentMethodNotAvailable: 'Vi preghiamo di comunicarci se il vostro metodo di pagamento preferito non è disponibile.',
    savePaymentMethod: 'Salva questo metodo di pagamento per acquisti futuri',
    termsAccept: '*Effettuando questo ordine, accetti i nostri',
    termsOfService: 'Termini di servizio',
    privacyNotice: 'e riconosci di aver letto e compreso la nostra',
    privacyPolicy: 'Informativa sulla privacy',
    unexpectedError: 'Si è verificato un errore imprevisto.',
    paymentProcessingTitle: 'Conferma del pagamento in corso…',
    paymentProcessingDescription: 'Il tuo ordine è stato ricevuto e stiamo confermando il pagamento. Potrebbe richiedere qualche secondo: non è necessario pagare di nuovo.',
    viewOrderStatus: "Visualizza lo stato dell'ordine",
    paymentFailedTitle: 'Il pagamento non è andato a buon fine',
    paymentFailedDescription: 'Il pagamento è stato rifiutato o non è stato completato, quindi non è stato addebitato nulla. Puoi riprovare con lo stesso o con un altro metodo di pagamento.',
    retryPayment: 'Riprova a pagare',
    orderReview: 'Riepilogo ordine',
    orderDescription: 'Ecco un elenco degli articoli del tuo ordine. (ID ordine: {{orderId}})',
    finishOrder: 'Completa il tuo ordine',
    reviewAndPay: 'Verifica il tuo ordine e procedi al pagamento.',
    emptyOrder: 'Questo ordine è vuoto. Elimina questo ordine e cerca nuovamente dei domini.',
    domainsUnavailable: 'Alcuni domini in questo ordine non sono più disponibili. Questo ordine non è valido. Elimina questo ordine e cerca nuovamente dei domini.',
    paymentMethods: 'Metodi di pagamento',
    newPaymentMethod: 'Nuovo metodo di pagamento',
    couponCode: 'Codice coupon',
    vatExempt: "(Non soggetto all'IVA svizzera)",
    vatIncluded: '(8.1% IVA incl.)',
    websiteHosting: 'Hosting web',
    notApplicable: 'Non applicabile',
    yourCart: 'Il tuo carrello',
    cartDescription: 'Inizia la tua tecnologia web da qui.',
    cartEmpty: 'Il tuo carrello è vuoto.',
    addMoreToCart: 'Aggiungi altro al carrello',
    continueToCheckout: 'Continua al pagamento',
    goToCheckout: 'Vai al pagamento',
    unpaidOrders: 'Ma hai ordini non pagati.',
    unpaidRenewalOrders: 'Ordini di rinnovo non pagati:',
    viewAmountsDue: 'Visualizza importi dovuti',
    amountsDue: 'Importi dovuti',
    amountsDueDescription: 'Controlla gli ordini di rinnovo non pagati e combinali in una fattura.',
    amountsDueEmpty: 'Al momento non ci sono ordini di rinnovo non pagati.',
    payAllInOneInvoice: 'Paga tutto in una fattura',
    renewalOrderDomainCount: '{{count}} voci di rinnovo dominio',
    viewOrders: 'Visualizza ordini',
    order: 'Ordine',
    thankYou: 'Grazie!',
    paymentReceived: 'Il tuo pagamento è stato ricevuto.',
    freeOrderPlaced: 'Hai effettuato un ordine gratuito.',
    orderProcessing: "Elaboreremo il tuo ordine e ti invieremo un'e-mail di conferma entro pochi minuti.",
    domainItems: 'Articoli dominio:',
    amountPaid: 'Importo pagato:',
    amountRemaining: 'Importo rimanente:',
    dateAndTime: 'Data e ora:',
    viewMyOrder: 'Visualizza il mio ordine {{id}}',
    goToMyWebsite: 'Vai al mio sito web',
    goToMyWebsites: 'Vai ai miei siti web',
    orderFrom: 'Ordine {{id}} del {{date}}',
    totalDue: 'Totale dovuto',
    invoiceNumber: 'Numero fattura',
    domainType: 'Dominio {{type}}',
    deleteOrder: 'Elimina ordine',
    deleteOrderConfirm: "Stai per eliminare l'ordine {{id}}. Sei sicuro di voler continuare?",
    orderDeletedSuccess: 'Ordine eliminato con successo',
    oneYear: '1 anno',
    oneMonth: '1 mese',
    upgradeToPlan: 'Passa al piano {{plan}}',
    plan: 'Piano {{plan}}',
    days: '{{count}} giorni',
    daysUntilDate: '({{count}} giorni fino al {{date}})',
    autoRenewMonthly: 'Se non cancelli, il tuo abbonamento si rinnoverà automaticamente ogni mese.',
    autoRenewYearly: 'Se non cancelli, il tuo abbonamento si rinnoverà automaticamente ogni anno.',
    summary: 'Riepilogo',
    cartSummary: 'Riepilogo del carrello.',
    cart: 'Carrello',
    registrantAddress: 'Indirizzo del registrante',
    billingAddress: 'Indirizzo di fatturazione',
    createOrder: 'Crea ordine',
    cartEmptyWithOrders: 'Il carrello è vuoto. Hai <link>ordini</link> in sospeso?',
    priceFreeFun: 'Niente è meglio che gratis!',
    priceCoffee: 'Circa il prezzo di un caffè',
    priceBeer: 'Circa il prezzo di una birra',
    priceLunch: 'Circa il prezzo di un pranzo semplice',
    priceLunchMenu: 'Circa il prezzo di un menu pranzo',
  },
  contact: {
    maintenance: {
      title: 'Contatti intestatari',
      description: 'Gestisci le persone o aziende registrate come intestatari dei domini.',
      edit: 'Modifica dati di contatto',
      defaultContact: 'Predefinito per gli acquisti',
      saved: 'Dati di contatto aggiornati.',
      sharedNotice:
        'La modifica aggiorna il contatto condiviso nel registro per tutti i domini che lo utilizzano, anche come contatto tecnico. I dati di fatturazione collegati seguono il contatto predefinito; le fatture esistenti restano invariate. Per un altro intestatario, usa Cambia intestatario nelle impostazioni del dominio.',
      linkedDomains: 'Domini di questo intestatario:',
      sameHolder: 'Confermo che questi sono i dati aggiornati della stessa persona o azienda.',
      newContactNotice: 'Creare un contatto non modifica gli intestatari esistenti né il contatto predefinito.',
      holderTitle: 'Intestatario del dominio',
      holderDescription: 'Scegli l’intestatario di questo dominio. Il dominio resta nel tuo account; DNS, contatto tecnico e fatturazione restano invariati.',
      currentHolder: 'Intestatario attuale',
      currentUnavailable: 'I dati dell’intestatario attuale non sono disponibili. Contatta il supporto.',
      newHolder: 'Nuovo intestatario',
      chooseHolder: 'Scegli un contatto',
      noOtherContacts: 'Non ci sono ancora altri contatti. Aggiungi un indirizzo del registrante per scegliere un nuovo titolare.',
      changeHolder: 'Cambia intestatario',
      holderNotice: 'Stai cambiando l’intestatario registrato di {{domain}} al contatto mostrato sopra.',
      holderConfirmation: 'Sono autorizzato dall’intestatario attuale a effettuare questa modifica e confermo il consenso del nuovo intestatario.',
      holderSaved: 'Intestatario del dominio modificato.',
    },
    createRegistrant: 'Crea titolare',
    registrantType: 'Tipo di titolare',
    billingType: 'Tipo di fatturazione',
    companyContact: 'Azienda',
    companyName: 'Nome azienda',
    vatId: 'Partita IVA',
    registrantContact: 'Contatto del titolare',
    registrantContactRequired: 'Non hai ancora creato un contatto titolare. Questo è richiesto dal registro.',
    registrantContactInfo: 'Le tue informazioni di contatto sono richieste dal registro.',
    continueToCheckout: 'Continua al pagamento',
    sameAsRegistrant: "Uguale all'indirizzo del titolare",
    legalNameDescription: 'Il tuo nome legale che verrà archiviato dal registro.',
    companyNameDescription: "Nome dell'azienda se la fatturazione è per un'azienda.",
    companyNameRegistrantDescription: "Nome dell'azienda se il titolare è un'azienda.",
    vatDescription: 'Partita IVA per clienti aziendali (facoltativo).',
    contactEmailDescription: 'Il tuo indirizzo e-mail di contatto.',
    enterPhoneNumber: 'Inserisci un numero di telefono',
    realNamePlaceholder: 'Nome completo',
    companyPlaceholder: 'Azienda',
    vatIdPlaceholder: 'CHE-123.456.789',
    streetAndNumber: 'Via e numero',
    additionalAddress: "Informazioni aggiuntive sull'indirizzo",
    state: 'Cantone',
    countryOrRegion: 'Paese o regione',
    vatIdLabel: 'Partita IVA:',
    addNewRegistrant: 'Aggiungi nuovo indirizzo del registrante',
  },
  account: {
    myAccount: 'Il mio account',
    manageAccountSettings: 'Gestisci le impostazioni del tuo account.',
    account: 'Account',
    orders: 'Ordini',
    domains: 'Domini',
    websiteHosting: 'Hosting web',
    logOut: 'Esci',
    admin: 'Admin',
    paymentMethods: 'Metodi di pagamento',
    paymentMethodsDescription: 'Gestisci i tuoi metodi di pagamento salvati.',
    noPaymentMethods: 'Nessun metodo di pagamento salvato.',
    setAsDefault: 'Imposta come predefinito',
    defaultPaymentMethodSet: 'Metodo di pagamento predefinito impostato con successo',
    paymentMethodDeleted: 'Metodo di pagamento eliminato con successo',
    expires: 'Scade {{month}}/{{year}}',
    default: 'Predefinito',
    // Avatar
    avatar: 'Avatar',
    avatarDescription: "Desidera aggiungere un'immagine del profilo? Può farlo qui.",
    removeAvatar: 'Rimuovi avatar',
    uploadAvatar: 'Carica avatar',
    avatarUpdated: 'Avatar aggiornato.',
    avatarUpdateFailed: "Impossibile aggiornare l'avatar.",
    avatarRemoved: 'Avatar rimosso.',
    selectValidImage: 'Seleziona un file immagine valido.',
    avatarUploadHint: "Carica un'immagine fino a 128x128 pixel. Le immagini più grandi verranno ridimensionate.",
    // Order overview
    orderTitle: 'Ordine',
    orderFrom: 'del {{date}}',
    openMenu: 'Apri menu',
    viewOrder: 'Visualizza ordine',
    pay: 'Paga',
    paymentStatus: 'Stato del pagamento:',
    invoiceStatusPaid: 'Pagato',
    invoiceStatusDraft: 'Bozza',
    invoiceStatusOpen: 'Aperto',
    invoiceStatusVoid: 'Annullato',
    invoiceStatusUncollectible: 'Inesigibile',
    discount: 'Sconto:',
    total: 'Totale:',
    notInitiated: '{{type}} non avviata',
    waitingForRegistry: 'In attesa di comunicazione con il registro',
    manageOrders: 'Visualizza e gestisci i tuoi ordini',
    noOrdersYet: 'Nessun ordine ancora',
    noOrdersDescription: 'Non hai ancora effettuato ordini.',
    // Profile
    manageYourDomains: 'Gestisci i tuoi domini',
    validEmailAddress: 'Inserisci un indirizzo e-mail valido.',
    emailDescription: 'Il tuo indirizzo e-mail viene utilizzato per accedere e ricevere notifiche e non può essere modificato.',
    displayName: 'Nome visualizzato',
    displayNameDescription: 'Inserisci il tuo nome completo o un nome visualizzato che preferisci.',
    displayNameHint: 'Utilizza un massimo di 32 caratteri.',
    displayNamePlaceholder: 'Come possiamo chiamarti?',
    recoveryEmail: 'E-mail di recupero',
    recoveryEmailDescription: "Non inviamo e-mail a questo indirizzo. Ti identifichiamo tramite questo indirizzo e-mail se perdi l'accesso al tuo account principale.",
    recoveryEmailHint: 'Utilizza un indirizzo e-mail valido.',
    // Delete account
    deleteAccount: 'Elimina account',
    deleteAccountDescription: 'Elimina definitivamente il tuo account e i dati collegati. L’operazione non può essere annullata.',
    deleteAccountBlockedDomains: 'Hai ancora domini registrati presso di noi. Trasferiscili prima a un altro registrar oppure eliminali:',
    deleteAccountBlockedOrder: 'Uno dei tuoi ordini è ancora in elaborazione. Riprova quando sarà completato.',
    deleteAccountBlockedAdmin: 'Gli account amministratore non possono essere eliminati qui.',
    deleteAccountBlockedImpersonation: 'Un account non può essere eliminato mentre viene utilizzato per delega.',
    deleteAccountDialogTitle: 'Eliminare definitivamente il tuo account?',
    deleteAccountDialogDescription: 'L’operazione non può essere annullata. Elimineremo definitivamente:',
    deleteAccountItemProfile: 'Il tuo profilo, le credenziali, i contatti e i metodi di pagamento salvati',
    deleteAccountItemOrders: 'Il tuo carrello e gli ordini non pagati',
    deleteAccountItemDns: 'Zone DNS e inoltri URL dei domini rimossi o trasferiti altrove',
    deleteAccountItemSites: 'I tuoi siti web ({{count}}) con tutti i file, i deployment e i domini personalizzati',
    deleteAccountItemSubscription: 'Il tuo abbonamento di hosting termina subito, senza rimborso',
    deleteAccountRetention: 'Le fatture dei pagamenti completati ({{count}}) vengono conservate per dieci anni, come richiede il diritto svizzero, e poi eliminate.',
    deleteAccountConfirmLabel: 'Digita il tuo indirizzo e-mail per confermare',
    deleteAccountReauth: 'Esci, accedi di nuovo e riprova, così possiamo confermare la tua identità.',
    deleteAccountSuccess: 'Il tuo account è stato eliminato.',
  },
  hosting: {
    websiteFallback: 'Sito web',
    createNewWebsite: 'Crea nuovo sito web',
    createStaticSite: 'Crea un sito statico',
    createStaticSiteDescription: 'Fornisci un nome e un sottodominio per il tuo sito.',
    siteName: 'Nome del sito',
    subdomain: 'Sottodominio',
    siteNamePlaceholder: 'Landing page, portfolio, blog, ecc.',
    subdomainPlaceholder: 'mio_sito',
    subdomainHint: '3-32 caratteri: a-z, 0-9, _',
    creating: 'Creazione in corso...',
    createSite: 'Crea sito',
    siteCreated: 'Sito creato',
    nameRequired: 'Il nome è obbligatorio',
    nameMaxLength: 'Il nome deve contenere al massimo 64 caratteri',
    subdomainMinLength: 'Il sottodominio deve contenere almeno 3 caratteri',
    subdomainMaxLength: 'Il sottodominio deve contenere al massimo 32 caratteri',
    subdomainCharsOnly: 'Sono consentiti solo a-z, 0-9 e _',
    noWebsitesYet: 'Nessun sito web',
    noWebsitesDescription: 'Non hai ancora creato nessun sito web. Inizia creando il tuo primo sito web.',
    deleteSite: 'Elimina sito',
    deleteSiteTitle: 'Eliminare "{{name}}"?',
    deleteSiteDescription: 'Questa azione rimuoverà permanentemente il sito, i suoi domini personalizzati e tutti i file distribuiti. Questa azione non può essere annullata.',
    deleting: 'Eliminazione in corso...',
    siteDeleted: 'Sito eliminato',
    renameSiteDescription: "Cambia solo il nome. L'indirizzo del tuo sito resta lo stesso.",
    siteRenamed: 'Sito rinominato',
    siteIconTitle: 'Icona',
    siteIconHelp: "Viene mostrata per questo sito nel Suo account; i visitatori non la vedono. Clicchi sull'icona per scegliere un'immagine (al massimo 500 KB).",
    redirectsNotForParked: 'Una pagina «Prossimamente» non ha reindirizzamenti.',
    deleteSiteSectionTitle: 'Elimina questo sito',
    publishingYourSite: 'Pubblicazione del tuo sito',
    savingFiles: 'Salvataggio dei tuoi file...',
    creatingNewVersion: 'Creazione nuova versione...',
    generatingPreview: 'Generazione anteprima...',
    makingItLive: 'Messa online...',
    mayTakeFewSeconds: 'Potrebbe richiedere qualche secondo...',
    siteIsLive: 'Il tuo sito è online!',
    redirectingToOverview: 'Reindirizzamento alla panoramica del tuo sito...',
    uploadZipArchive: 'Carica archivio Zip',
    uploadZipDescription: 'Carica il tuo sito statico come file .zip. I file vengono estratti nella tua bozza, dove puoi visualizzarli in anteprima e modificarli.',
    chooseZipFile: 'Scegli un file .zip.',
    onlyZipSupported: 'Sono supportati solo file .zip.',
    uploading: 'Caricamento...',
    uploadingWait: 'Attendi mentre il tuo file viene caricato',
    extractingFiles: 'Estrazione file...',
    extractingToWorkspace: 'Estrazione del tuo file zip nella tua bozza',
    uploadComplete: 'Caricamento completato!',
    redirectingToEditor: 'Apertura della tua bozza...',
    uploadFailed: 'Caricamento non riuscito',
    tryAgain: 'Riprova',
    replaceExistingFiles: 'Sostituire i file esistenti?',
    existingFilesCount: 'La tua bozza contiene <strong>{{count}}</strong> file esistente/i.',
    replaceAllWarning: 'Il caricamento di questo zip <strong>sostituirà tutti i file esistenti</strong>.',
    replaceAllFiles: 'Sostituisci tutti i file',
    uploadAndExtract: 'Carica ed estrai',
    afterExtraction: "Dopo l'estrazione, puoi visualizzare in anteprima e modificare i tuoi file prima della pubblicazione.",
    filesExtracted: 'File estratti con successo!',
    active: 'Attivo',
    updated: 'Aggiornato {{date}}',
    selectImageFile: 'Seleziona un file immagine',
    imageTooLarge: "L'immagine deve essere inferiore a 500KB",
    faviconUpdated: 'Favicon aggiornata',
    faviconUpdateFailed: 'Aggiornamento favicon non riuscito',
    clickToChangeFavicon: 'Fai clic per cambiare la favicon',
    // Editor file tree
    files: 'File',
    newFile: 'Nuovo file',
    newFolder: 'Nuova cartella',
    uploadFiles: 'Carica file',
    rename: 'Rinomina',
    moveTo: 'Sposta in...',
    noFilesYet: 'Nessun file presente',
    moveFile: 'Sposta file',
    moveFileDescription: 'Seleziona una cartella di destinazione per',
    current: '(attuale)',
    rootFolder: '/ (radice)',
    // Editor code panel
    noFileSelected: 'Nessun file selezionato',
    selectFileToEdit: 'Seleziona un file per iniziare a modificarlo',
    modified: 'Modificato',
    download: 'Scarica',
    imagePreview: 'Anteprima immagine',
    videoPreview: 'Anteprima video',
    audioPreview: 'Anteprima audio',
    pdfPreview: 'Anteprima PDF',
    binaryFile: 'File binario',
    cannotPreview: 'Questo tipo di file non può essere visualizzato in anteprima qui.',
    downloadFile: 'Scarica file',
    robotsTxtHint:
      'Gli URL di anteprima restituiscono sempre <code class="bg-blue-500/20 px-1 rounded">Disallow: /</code> per impedire ai motori di ricerca di indicizzare i contenuti di anteprima. Il tuo robots.txt funzionerà correttamente una volta pubblicato.',
    // Editor empty state
    workspaceEmpty: 'Ancora niente qui',
    chooseHowToStart: 'Scegli come iniziare a creare il tuo sito',
    startFresh: 'Inizia da zero',
    startFreshDescription: 'Crea un file index.html vuoto',
    createPage: 'Crea una pagina',
    createPageDescription: 'Compila un modulo. Nessun codice.',
    createPageFailed: 'Impossibile creare la pagina',
    advancedOptions: 'Avanzate',
    uploadFilesDescription: 'Carica file e cartelle',
    uploadZip: 'Carica Zip',
    uploadZipShortDescription: 'Estrai un archivio .zip',
    uploadWebsite: 'Carica il tuo sito',
    uploadWebsiteDescription: 'Uno zip del tuo sito, oppure il singolo file che ti ha dato il tuo assistente IA.',
    chooseUploadFile: 'Scegli un file .zip o .html.',
    onlyZipOrHtmlSupported: 'Sono supportati solo file .zip e .html.',
    htmlTooLarge: 'Questo file è troppo grande. Il limite è {{limit}}.',
    htmlUploaded: 'La tua pagina è stata salvata come index.html.',
    uploadWebsiteHint: 'Uno zip viene estratto nel tuo sito. Un singolo file .html diventa la tua pagina iniziale (index.html).',
    htmlReplacesIndex: 'Questo file sostituisce il tuo index.html attuale. Gli altri file restano.',
    uploadNoFileYet: 'Nessun file ancora? Scopri come crearne uno con ChatGPT o Claude.',
    buildWithAssistant: 'Crealo con il tuo assistente IA',
    buildWithAssistantDescription: 'Con ChatGPT o Claude, poi carica il singolo file che ti dà.',
    aiCardTitle: 'Crealo con ChatGPT o Claude',
    aiCardDescription: 'Il tuo assistente IA ti fa qualche domanda e crea la tua pagina. Carichi un solo file.',
    aiCardButton: 'Mostrami come',
    chooseTemplate: 'Scegli un template',
    chooseTemplateDescription: 'Inizia con un design accattivante',
    loadFromVersion: 'Carica da una versione',
    loadFromVersionDescription: 'Copia da una versione esistente',
    beta: 'Beta',
    latest: 'Più recente',
    // Template gallery
    templateGalleryDescription: 'Inizia con un template dal design curato e personalizzalo secondo le tue esigenze',
    all: 'Tutti',
    applying: 'Applicazione in corso...',
    useThisTemplate: 'Usa questo template',
    preview: 'Anteprima',
    back: 'Indietro',
    needMoreTemplates: 'Hai bisogno di più template?',
    useTemplate: 'Usa template',
    templateApplied: 'Template "{{name}}" applicato con successo!',
    failedToApplyTemplate: 'Impossibile applicare il template',
    // Deployments
    history: 'Cronologia',
    noVersionsYet: 'Nessuna versione presente. A ogni pubblicazione qui viene salvata una versione.',
    publishedFromEditor: 'Pubblicato dalla tua bozza',
    fileUpload: 'Caricamento file',
    zipUpload: 'Caricamento Zip',
    live: 'Online',
    updatedTime: 'Aggiornato:',
    // Deployment page actions
    version: 'Versione',
    failedToRestore: 'Impossibile ripristinare questa versione.',
    versionNowLive: 'La versione è ora online!',
    failedToEditCopy: 'Impossibile copiare questa versione per modificarla.',
    editCopyReady: 'Ora stai modificando una copia di questa versione.',
    versionDeleted: 'Versione eliminata',
    failedToDeleteVersion: 'Eliminazione della versione non riuscita.',
    previewVersion: 'Anteprima versione',
    editCopy: 'Modifica una copia di questa versione',
    replaceDraftTitle: 'Sostituire la bozza?',
    replaceDraftDescription: 'Tutti i file della tua bozza verranno sostituiti con questa versione. Le modifiche non pubblicate andranno perse.',
    deleteVersion: 'Elimina versione',
    deleteVersionTitle: 'Eliminare questa versione?',
    deleteVersionDescription: 'Questa azione rimuoverà permanentemente questa versione e i suoi file archiviati. Questa azione non può essere annullata.',
    restoring: 'Ripristino in corso...',
    restoreVersion: 'Ripristina questa versione',
    downloadVersion: 'Scarica questa versione (zip)',
    // Share draft and download (Edit toolbar)
    downloadFiles: 'Scarica i file',
    shareDraft: 'Condividi bozza',
    shareDraftTitle: 'Condividi la tua bozza',
    shareDraftDescription: 'Chiunque abbia il link può vedere la tua bozza fino alla scadenza del link. Va su Internet con il tuo dominio solo quando pubblichi.',
    shareDraftDuration: 'Il link funziona per',
    shareDraft1d: '1 giorno',
    shareDraft7d: '7 giorni',
    shareDraft30d: '30 giorni',
    shareDraftCreate: 'Crea link',
    shareDraftLink: 'Link alla tua bozza',
    shareDraftExpires: 'Scade il {{date}}',
    shareDraftCopyManually: 'Il link è selezionato: copialo con Ctrl+C o ⌘C.',
    copyLink: 'Copia',
    copied: 'Copiato',
    stopSharing: 'Interrompi condivisione',
    stopSharingConfirm: 'Tutti i link creati finora smetteranno di funzionare.',
    stopSharingDone: 'I link alla tua bozza non funzionano più.',
    // Deployment overview
    previewUrl: 'URL di anteprima',
    domains: 'Domini',
    createdVia: 'Creato tramite',
    editor: 'Modificato online',
    git: 'Git',
    madeLive: 'Messo online',
    duration: 'Durata',
    size: 'Dimensione',
    buildFailed: 'Build non riuscita',
    versionPreview: 'Anteprima versione',
    openPreview: 'Apri anteprima',
    currentlyLive: 'Attualmente online',
    connectedDomains: 'Domini collegati',
    // Deployment status
    statusReady: 'Pronto',
    statusFailed: 'Non riuscito',
    statusBuilding: 'In costruzione',
    statusUploaded: 'Caricato',
    statusPending: 'In attesa',
    // Empty deployment
    versionNotFound: 'Versione non trovata',
    versionNotFoundDescription: 'Questa versione non può essere caricata. Potrebbe essere stata eliminata o si è verificato un errore.',
    // Performance panel
    runAnalysis: 'Esegui analisi',
    analyzing: 'Analisi in corso...',
    screenshot: 'Screenshot',
    performance: 'Prestazioni',
    // Files upload
    uploadFilesTitle: 'Carica file',
    uploadFilesDialogDescription: 'Carica i file direttamente nella tua bozza. Puoi visualizzarli in anteprima e modificarli prima della pubblicazione.',
    selectAtLeastOneFile: 'Seleziona almeno un file.',
    uploadedFilesSuccess: '{{count}} file caricato/i con successo!',
    uploadFailedRetry: 'Caricamento non riuscito. Riprova.',
    replaceExistingFilesQuestion: 'Sostituire i file esistenti?',
    existingFileCount: 'La tua bozza contiene <strong>{{count}}</strong> file esistente/i.',
    uploadWillReplaceAll: 'Il caricamento <strong>sostituirà tutti i file esistenti</strong>.',
    clearingWorkspace: 'Svuotamento della bozza...',
    removingExistingFiles: 'Rimozione dei file esistenti',
    uploadingProgress: 'Caricamento... ({{current}}/{{total}})',
    pleaseWaitUploading: 'Attendi mentre i tuoi file vengono caricati',
    uploadLimitsExceeded: 'Limiti di caricamento superati',
    uploadLimitsDescription: 'I file selezionati superano i limiti per il caricamento di file singoli.',
    tooManyFiles: 'Troppi file:',
    youSelected: 'Hai selezionato {{count}} file, ma il limite è di {{max}} file.',
    filesExceedSize: '{{count}} file superano il limite di dimensione di {{limit}}:',
    andMore: '...e altri {{count}}',
    useZipUpload: 'Usa il caricamento ZIP',
    useZipUploadDescription:
      "Per caricare molti file o file di grandi dimensioni, comprimi il tuo progetto in un file <strong>.zip</strong> e utilizza l'opzione <strong>Carica Zip</strong>. È più veloce e supporta progetti più grandi.",
    goBack: 'Torna indietro',
    selectFiles: 'Seleziona file',
    selectFolder: 'Seleziona cartella',
    filesSelected: '{{count}} file selezionato/i',
    clearAll: 'Cancella tutto',
    useZipForLarger: '<strong>Usa il caricamento ZIP</strong> per progetti più grandi.',
    selectFilesToUpload: 'Seleziona file o una cartella da caricare nella tua bozza',
    fileLimitsInfo: 'Limite: {{maxFiles}} file, {{maxSize}} per file. Per caricamenti più grandi, usa ZIP.',
    uploadCount: 'Carica {{count}} file',
    upload: 'Carica',
    // Static site domains
    domainAdded: 'Dominio aggiunto',
    domainAddedWithRedirect: 'www.{{domain}} aggiunto. {{domain}} verrà reindirizzato automaticamente a www.{{domain}}.',
    upgradeToAddDomains: "Effettua l'upgrade per aggiungere domini personalizzati",
    upgradeToAddDomainsWithCount: "Effettua l'upgrade per aggiungere domini ({{used}}/{{limit}})",
    addDomain: 'Aggiungi dominio',
    addDomainWithCount: 'Aggiungi dominio ({{used}}/{{limit}})',
    addADomain: 'Aggiungi un dominio',
    enterDomainToMap: 'Inserisci il dominio da associare a questo sito.',
    domainSource: 'Origine del dominio',
    buyADomain: 'Acquista un dominio',
    myDomains: 'I miei domini',
    thirdPartyDomains: 'Domini di terze parti',
    myDomainsDnsHint: 'Gestiremo automaticamente DNS e certificato SSL per Lei.',
    thirdPartyDnsHint: 'Dopo aver aggiunto il dominio, Le mostriamo i record DNS da creare presso il Suo provider DNS.',
    subdomainOptional: 'Sottodominio (facoltativo)',
    selectADomain: 'Seleziona un dominio',
    noDomainsWithUs: 'Non hai ancora domini registrati con noi.',
    saving: 'Salvataggio\u2026',
    addDomainButton: 'Aggiungi dominio',
    // Delete domain
    removeDomainTitle: 'Rimuovere "{{hostname}}"?',
    removeDomainMapping: "Questa azione rimuoverà l'associazione del dominio da questo sito. Potrà aggiungerlo nuovamente in seguito.",
    domainRemoved: 'Dominio rimosso',
    removing: 'Rimozione\u2026',
    // Analytics
    analytics: 'Analisi',
    days7: '7 giorni',
    days30: '30 giorni',
    days90: '90 giorni',
    visitors: 'Visitatori',
    pageViews: 'Visualizzazioni di pagina',
    bandwidth: 'Larghezza di banda',
    visitorsAndPageViews: 'Visitatori e visualizzazioni di pagina',
    topPages: 'Pagine principali',
    views: 'Visualizzazioni',
    topReferrers: 'Referrer principali',
    countries: 'Paesi',
    devices: 'Dispositivi',
    browsers: 'Browser',
    noData: 'Nessun dato',
    noPageData: 'Nessun dato sulle pagine',
    noReferrerData: 'Nessun dato sui referrer',
    noCountryData: 'Nessun dato sui paesi',
    vsPrevious: 'rispetto al precedente',
    noAnalyticsYet: 'Nessun dato di analisi disponibile',
    noAnalyticsDescription: 'I dati di analisi appariranno qui quando il tuo sito inizierà a ricevere traffico.',
    // Static sites page
    hostFastSecure: 'Ospita siti web veloci e sicuri senza server.',
    upgradeToCreateMore: "Effettua l'upgrade per crearne di più",
    // Editor page
    takingLonger: 'Ci sta mettendo più del previsto',
    uploadRunningFor: 'Il caricamento è in corso da {{time}}.',
    extractionRunningFor: "L'estrazione è in corso da {{time}}.",
    cancelAndRetry: 'Puoi annullare e riprovare con un file più piccolo.',
    cancelStartOver: 'Annulla & ricomincia',
    pleaseWaitProcessing: 'Attendi mentre i tuoi file vengono elaborati',
    elapsed: 'Trascorso: {{time}}',
    extractionFailed: 'Estrazione non riuscita',
    errorProcessingFiles: "Si è verificato un errore durante l'elaborazione dei tuoi file.",
    troubleshootingTips: 'Suggerimenti per la risoluzione dei problemi:',
    tipZipNotCorrupted: 'Assicurati che il file ZIP non sia corrotto',
    tipSmallerZip: 'Prova con un file ZIP più piccolo (meno di 100 MB)',
    tipNoSpecialChars: 'Evita caratteri speciali nei nomi di file/cartelle',
    tipValidFiles: 'Assicurati che il ZIP contenga file di sito web statico validi',
    unsavedChangesTitle: 'Scartare le modifiche non salvate?',
    unsavedChangesDiscard: 'Le modifiche a questo file non sono state salvate e andranno perse.',
    discardChanges: 'Scarta modifiche',
    fileCountLabel: '{{count}} file',
    fromVersion: 'Dalla versione #{{version}}',
    deleteFileConfirm: 'Eliminare "{{path}}"?',
    deleteFileDescription: 'Verrà rimosso dalla tua bozza. Le versioni pubblicate non sono interessate.',
    tooManyFilesInline: 'Troppi file ({{count}}/{{max}}).',
    filesExceedInline: '{{count}} file superano {{limit}}.',
    andMoreFiles: '...e altri {{count}} file',
    failedToLoadFile: 'Caricamento del file non riuscito',
    failedToLoadPreview: "Caricamento dell'anteprima non riuscito",
    fileSaved: 'File salvato',
    failedToSaveFile: 'Salvataggio del file non riuscito',
    failedToCreateFile: 'Creazione del file non riuscita',
    folderCreated: 'Cartella creata',
    failedToCreateFolder: 'Creazione della cartella non riuscita',
    fileDeleted: 'File eliminato',
    failedToDeleteFile: 'Eliminazione del file non riuscita',
    fileRenamed: 'File rinominato',
    failedToRenameFile: 'Rinomina del file non riuscita',
    failedToCreateStarter: 'Creazione del file di avvio non riuscita',
    workspaceInitialized: 'Bozza copiata dalla versione',
    failedToLoadDeployment: 'Caricamento dal deployment non riuscito',
    publishStoppedSaveFailed: 'Non è stato possibile salvare le modifiche, quindi non è stato pubblicato nulla. Riprova.',
    failedToPublish: 'Pubblicazione non riuscita',
    workspaceCleared: 'Bozza svuotata',
    failedToClearWorkspace: 'Svuotamento della bozza non riuscito',
    startOver: 'Ricomincia',
    startOverTitle: 'Ricominciare da zero?',
    startOverDescription: 'Questo eliminerà tutti i file della tua bozza per ricominciare da capo. Le versioni pubblicate non saranno interessate.',
    publish: 'Pubblica',
    publishing: 'Pubblicazione...',
    publishYourWebsite: 'Pubblica il tuo sito web',
    filesTooLarge: 'File troppo grandi',
    uploadMaxFiles: 'Puoi caricare fino a {{max}} file alla volta.',
    useZipForBulk: 'Usa il caricamento ZIP per file in massa',
    useZipForBulkDescription:
      'Per caricare molti file o file di grandi dimensioni, usa invece l\'opzione Carica ZIP. Vai alla panoramica del sito e usa "Carica ZIP" per caricare l\'intero progetto in una volta sola.',
    goToOverview: 'Vai alla panoramica',
    // Site overview page
    visitSite: 'Visita il sito',
    draft: 'Bozza',
    liveUrl: 'URL live',
    noCustomDomain: 'Nessun dominio personalizzato configurato.',
    addOne: 'Aggiungine uno',
    moreDomains: '+{{count}} altro/i dominio/i',
    previewOnly: 'Solo anteprima',
    previewOnlyDescription: 'Questo sito è visibile solo a chi ha il link di anteprima. Pubblicalo per ottenere un indirizzo pubblico.',
    viewLive: 'Visualizza live',
    getStarted: 'Inizia',
    getStartedDraftDescription: 'Crea la tua pagina, poi scegli un piano per pubblicarla.',
    getStartedDescription: 'Non è ancora stato pubblicato nulla. Crea la tua pagina, poi pubblicala.',
    editYourPage: 'Modifica la tua pagina',
    sitePreview: 'Anteprima del sito',
    historyLink_one: 'Cronologia ({{count}} versione)',
    historyLink_other: 'Cronologia ({{count}} versioni)',
    visitorsLast30Days: 'Visitatori, ultimi 30 giorni',
    visitorsLast30DaysCount: 'Visitatori, ultimi 30 giorni: {{count}}',
    versionCount_one: '{{count}} versione',
    versionCount_other: '{{count}} versioni',
    visitorsLast30DaysValue: '{{count}} negli ultimi 30 giorni',
    nextFinishTitle: 'Completa la tua pagina',
    nextFinishText: 'La tua pagina non è ancora su Internet. Completala, poi fai clic su Pubblica.',
    nextPublishTitle: 'Pubblica la tua pagina',
    nextPublishText: 'Puoi condividere la tua bozza con il suo link di anteprima. Scegli un piano per metterla su Internet.',
    nextConnectTitle: 'Collega il tuo dominio',
    nextConnectText: 'La tua pagina è online su {{address}}. Collega il tuo dominio perché i visitatori la trovino con il tuo nome.',
    nextFinishConnectingTitle: 'Completa il collegamento di {{hostname}}',
    nextFinishConnectingText: 'Il dominio attende i suoi record DNS. La scheda Domini mostra cosa impostare.',
    showDnsRecords: 'Mostra record DNS',
    nextReplaceParkedTitle: 'Sostituisci con una vera pagina',
    nextReplaceParkedText: 'Un vero sito web richiede un piano.',
    nextReplaceParkedPlanText: 'Trasforma la tua pagina «Prossimamente» in una vera pagina che modifichi con un modulo.',
    replaceParkedButton: 'Sostituisci',
    replaceParkedDialogTitle: 'Sostituire con una vera pagina?',
    replaceParkedDialogText: 'La tua pagina «Prossimamente» diventa una vera pagina che modifichi con un modulo. Conta nel tuo piano e va online subito.',
    replaceParkedConverting: 'Sostituzione...',
    seePlans: 'Vedi i piani',
    // Coming-soon page on a domain registered at YWT
    putPageOnDomainTitle: 'Metti una pagina su {{domain}}',
    putPageOnDomainText: 'Mostra ai visitatori una pagina mentre crei il tuo sito web. Gratis per i domini registrati presso YWT.',
    putPageOnDomainButton: 'Crea la pagina',
    putPageDialogTitle: 'Una pagina «Prossimamente» per {{domain}}',
    putPageDialogDescription: 'I visitatori di {{domain}} vedono questa pagina finché il tuo sito web non è pronto. Puoi modificarla in qualsiasi momento.',
    putItOnline: 'Metti online',
    puttingOnline: 'Pubblicazione in corso...',
    parkedHeadline: 'Titolo',
    parkedMessage: 'Messaggio',
    parkedContactEmail: 'E-mail di contatto (facoltativa)',
    parkedDefaultMessage: 'Stiamo costruendo qualcosa di speciale.',
    parkedHeadlineRequired: 'Inserisci un titolo.',
    parkedMessageRequired: 'Inserisci un messaggio.',
    parkedTooLong: 'Al massimo {{max}} caratteri.',
    parkedEmailInvalid: 'Inserisci un indirizzo e-mail valido.',
    parkedEditTitle: 'La tua pagina «Prossimamente»',
    parkedEditDescription: 'I visitatori di {{domain}} vedono questa pagina. Salvando, le modifiche vanno online.',
    parkedDomainsNote: 'Questa pagina viene mostrata su {{domain}} e www.{{domain}}.',
    comingSoonBadge: 'Pagina «Prossimamente»',
    // Business page (a one-page website made from a form)
    businessEditTitle: 'La tua pagina',
    businessEditDescription: 'Compila il modulo; l’anteprima mostra la tua pagina. «Salva» conserva le modifiche, «Pubblica» le mette su Internet.',
    businessName: 'Nome',
    businessTagline: 'Slogan (facoltativo)',
    businessAbout: 'Chi siamo (facoltativo)',
    businessServices: 'Servizi (facoltativo)',
    businessService: 'Servizio {{n}}',
    businessRemoveService: 'Rimuovi servizio {{n}}',
    businessAddService: 'Aggiungi un servizio',
    businessHours: 'Orari di apertura (facoltativo)',
    businessPhone: 'Telefono (facoltativo)',
    businessEmail: 'E-mail (facoltativo)',
    businessAddress: 'Indirizzo (facoltativo)',
    businessTheme: 'Colori',
    businessThemeLight: 'Chiaro',
    businessThemeDark: 'Scuro',
    businessThemeWarm: 'Caldo',
    businessThemeCool: 'Freddo',
    businessNameRequired: 'Inserisci un nome.',
    businessPhoneInvalid: 'Usa solo cifre, spazi e + ( ) -.',
    businessPhoto: 'Foto (facoltativo)',
    businessPhotoHint: 'JPEG, PNG o WebP, fino a 2 MB. Viene salvata subito.',
    businessPhotoShown: 'La tua foto è in cima alla pagina.',
    businessPhotoChoose: 'Scegli una foto',
    businessPhotoReplace: 'Sostituisci foto',
    businessPhotoRemove: 'Rimuovi foto',
    businessPhotoWrongType: 'Scegli un’immagine JPEG, PNG o WebP.',
    businessPhotoTooLarge: 'La foto supera i 2 MB.',
    businessPhotoFailed: 'Impossibile salvare la foto',
    businessPreviewTitle: 'Anteprima della tua pagina',
    businessPreviewEmpty: 'L’anteprima appare qui.',
    businessPreviewUpdating: 'Aggiornamento...',
    businessSaved: 'Pagina salvata',
    businessSaveFailed: 'Impossibile salvare la pagina',
    unsavedPageDiscard: 'Le modifiche a questa pagina non sono state salvate e andranno perse.',
    businessPageBadge: 'Pagina',
    // Custom domains page
    primaryDomainUpdated: 'Dominio principale aggiornato',
    failedToSetPrimary: 'Impostazione del dominio principale non riuscita',
    domainConnected: 'Collegato',
    invalidConfiguration: 'Configurazione non valida',
    pendingDns: 'DNS in attesa',
    customDomains: 'Domini personalizzati',
    customDomainsDescription: 'Collega il tuo dominio a questo sito web',
    notLiveYetWarning: 'Questo sito web non è ancora online. I seguenti domini non avranno effetto.',
    noCustomDomainsYet: 'Nessun dominio personalizzato ancora.',
    primary: 'PRINCIPALE',
    refreshStatus: 'Aggiorna stato',
    setAsPrimary: 'Imposta come principale',
    setAsPrimaryNotConnected: '(non ancora collegato)',
    setAsPrimaryNotForParked: '(non per una pagina «Prossimamente»)',
    primaryLabel: '(Principale)',
    dnsConfigRequired: 'Configurazione DNS necessaria',
    dnsConfigDescription: 'Aggiungi il seguente record DNS presso il tuo provider di dominio per verificare la proprietà.',
    dnsPropagationNote: "Le modifiche DNS richiedono generalmente circa mezz'ora, ma possono richiedere fino a 48 ore per la propagazione. Verifichiamo automaticamente ogni 30 secondi.",
    // Hosting plans page
    plansTitle: 'Hosting di siti statici',
    plansSubtitle: 'Nessuna configurazione complessa. Nessun costo nascosto. Hosting semplice, veloce, sicuro e affidabile.',
    salesClosedTitle: 'L’hosting statico non è più disponibile',
    salesClosedDescription: 'L’hosting statico non è più offerto ai nuovi clienti. Gli abbonamenti esistenti proseguono fino alla data di scadenza.',
    salesClosedLearnMore: 'Informazioni sull’hosting statico',
    siteLimitReached: 'Limite di siti web raggiunto',
    customDomainLimitReached: 'Limite di domini personalizzati raggiunto',
    tierPlan: 'Piano {{tier}}',
    alreadySubscribed: "Sei già abbonato all'hosting statico.",
    manageYourPlan: 'Gestisci il tuo piano',
    featureHttpsTitle: 'HTTPS incluso',
    featureHttpsDesc: 'Nessun certificato da gestire. Sicuro per impostazione predefinita.',
    featureFastTitle: 'Caricamento veloce',
    featureFastDesc: 'Le pagine statiche si caricano rapidamente, senza codice server da attendere.',
    featureDomainsTitle: 'Domini personalizzati',
    featureDomainsDesc: 'Configurazione semplice per i tuoi domini.',
    featureSwissTitle: 'Datacenter svizzero',
    featureSwissDesc: "I dati rimangono nell'infrastruttura svizzera.",
    billingMonthly: 'Mensile',
    billingYearly: 'Annuale',
    savePercent: 'Risparmia {{percent}}%',
    billedMonthly: 'fatturato mensilmente',
    billedYearlyFor: 'fatturato annualmente per',
    noSubscriptionRequired: 'nessun abbonamento o pagamento richiesto',
    freeTrialDesc: 'Prova e costruisci prima di prendere una decisione.',
    startForFree: 'Inizia gratis',
    oneWebsite: '1 sito web',
    embeddedEditor: 'Editor di codice integrato',
    fileZipUpload: 'Caricamento file/Zip',
    previewLinkFeature: 'Link di anteprima da condividere',
    publishNeedsPlanFeature: 'La pubblicazione richiede un piano',
    noCustomDomainFeature: 'Nessun dominio personalizzato',
    publishOnStarter: 'Pubblica il tuo sito con un dominio personalizzato con il piano Starter.',
    popularLabel: 'Popolare',
    starterDesc: 'Tutto il necessario per gestire un vero sito web.',
    yourCurrentPlan: 'Il tuo piano attuale',
    downgradeToStarter: 'Passa a Starter',
    getStarter: 'Scegli Starter',
    featuresFromFree: 'Funzionalità del piano gratuito',
    oneCustomDomain: '1 dominio personalizzato',
    customDomainTooltip: 'Usa il tuo dominio (es. tuonome.ch). La registrazione del dominio non è inclusa.',
    websiteAnalysis: 'Analisi e monitoraggio del sito web',
    fastSecureDeliveryFeature: 'Distribuzione veloce e sicura con HTTPS',
    emailSupportFeature: 'Supporto via e-mail',
    fourteenDayGuarantee: 'Garanzia di rimborso di 14 giorni',
    perfectForPersonal: 'Perfetto per siti personali e piccole attività.',
    businessDesc: 'Per più siti web e un utilizzo maggiore.',
    upgradeToBusinessButton: 'Passa a Business',
    chooseBusiness: 'Scegli Business',
    featuresFromStarter: 'Funzionalità del piano Starter',
    upToFiveWebsites: 'Fino a 5 siti web',
    upToTenDomains: 'Fino a 10 domini personalizzati',
    higherTraffic: 'Traffico maggiore',
    prioritySupport: 'Supporto e-mail prioritario',
    thirtyDayGuarantee: 'Garanzia di rimborso di 30 giorni',
    needMoreWebsites: 'Hai bisogno di più di 5 siti web? Parliamone.',
    moneyBackTitle: 'Garanzia di rimborso fino a 30 giorni',
    moneyBackDesc: 'Entro il periodo di garanzia di rimborso, se non sei soddisfatto del nostro servizio, ti rimborseremo. Senza fare domande.',
    whatsIncludedAll: 'Cosa è incluso in tutti i piani',
    httpsIncludedFeature: 'HTTPS incluso',
    managedDns: 'DNS gestito',
    noServerMaintenance: 'Nessuna manutenzione del server',
    fairUseTraffic: 'Traffico fair use',
    noHiddenFeesFeature: 'Nessun costo nascosto',
    fairUseNote: 'Si applica il fair use. Ti contatteremo prima che vengano raggiunti eventuali limiti.',
    faqWhatIsStaticQ: "Cos'è l'hosting di siti web statici?",
    faqWhatIsStaticA:
      "L'hosting statico serve file HTML, CSS e JavaScript pre-costruiti direttamente ai visitatori. È perfetto per landing page, portfolio, documentazione, blog creati con strumenti come Hugo, Jekyll o Next.js (esportazione statica) e applicazioni a pagina singola (React, Vue, ecc.).",
    faqDynamicQ: 'Posso eseguire contenuti dinamici come PHP o database?',
    faqDynamicA:
      "No. L'hosting statico serve solo file \u2014 non c'è elaborazione lato server. Se hai bisogno di PHP, backend Node.js o database, ti servirà una soluzione di hosting diversa. Tuttavia, puoi utilizzare API esterne e funzioni serverless per funzionalità dinamiche.",
    faqCustomDomainQ: 'Come collego il mio dominio?',
    faqCustomDomainA:
      'Dopo aver creato il tuo sito web, vai alla scheda Domini e aggiungi il tuo dominio. Ti forniremo i record DNS da configurare. Se il tuo dominio è registrato con noi, il DNS viene configurato automaticamente. I certificati HTTPS vengono emessi automaticamente una volta configurato il DNS.',
    faqDeployQ: 'Come faccio a pubblicare il mio sito web?',
    faqDeployA: 'Modifica la tua pagina direttamente nel browser, carica file o un archivio ZIP, poi fai clic su Pubblica. Trovi tutto nella dashboard del tuo sito.',
    faqHttpsQ: 'HTTPS/SSL è incluso?',
    faqHttpsA:
      'Sì! Tutti i siti web ricevono certificati HTTPS gratuiti automaticamente. Una volta configurato correttamente il DNS del tuo dominio, emettiamo e rinnoviamo i certificati per te \u2014 nessun passaggio manuale richiesto.',
    faqVatQ: "Come viene gestita l'IVA?",
    faqVatA:
      "Il prezzo visualizzato è lo stesso per tutti. Per i clienti svizzeri, l'8.1% di IVA è incluso nel prezzo (indicato nelle fatture). I clienti al di fuori della Svizzera pagano lo stesso importo, ma l'IVA svizzera non si applica.",
    faqRefundQ: 'Qual è la garanzia di rimborso?',
    faqRefundA: 'Se non sei soddisfatto entro il periodo di garanzia (14 giorni per Starter, 30 giorni per Business), contattaci e ti emetteremo un rimborso completo \u2014 senza fare domande.',
    faqFreePlanQ: 'Posso usare il piano gratuito per creare il mio sito web?',
    faqFreePlanA: 'Sì. Con il piano gratuito puoi creare la tua pagina e condividerla con un link di anteprima. Per pubblicarla su Internet con il tuo dominio serve un piano.',
    faqUpgradeQ: 'Posso aggiornare il mio piano in seguito?',
    faqUpgradeA: 'Sì. Puoi passare da Starter a Business in qualsiasi momento. Calcoleremo la differenza proporzionale per il periodo rimanente del tuo abbonamento.',
    faqFairUsageQ: 'Qual è la politica di fair use?',
    faqFairUsageA:
      'Non imponiamo limiti rigidi di traffico, ma ci aspettiamo un utilizzo normale del sito web. Se il tuo sito riscontra picchi insoliti (ad es. traffico virale o abusi), ti contatteremo prima di intraprendere qualsiasi azione. La stragrande maggioranza dei siti web non si avvicina mai ad alcun limite.',
    faqDataLocationQ: 'Dove viene archiviato il mio sito web?',
    faqDataLocationA: "I file del tuo sito sono archiviati in un'infrastruttura situata a Zurigo, in Svizzera.",
    faqAnalyticsQ: 'Offrite analisi del sito web?',
    faqAnalyticsA:
      "Sì! Forniamo analisi delle prestazioni che mostrano la velocità di caricamento del tuo sito web, i Core Web Vitals e suggerimenti per l'ottimizzazione. E anche analisi dei visitatori come visualizzazioni di pagina, visitatori, dispositivi, browser, referrer, paesi, ecc.",
    faqSupportQ: 'Come posso ottenere supporto?',
    faqSupportA: 'Scrivici a <email>support@ywt.ch</email>. I clienti del piano Business ricevono supporto prioritario con tempi di risposta più rapidi.',
    // Path redirects
    redirectsTitle: 'Reindirizzamenti di percorso',
    redirectsDescription: 'Reindirizza un percorso specifico del tuo sito verso un altro URL, su questo sito o altrove.',
    redirectsHowItWorksTitle: 'Come funzionano i reindirizzamenti di percorso',
    redirectsHowItWorksBody:
      "Le regole corrispondono esattamente al percorso ('/blog' corrisponde anche a '/blog/') e vengono applicate prima dei file del tuo sito — una regola vale anche se a quel percorso esiste ancora un file. Le modifiche sono attive entro circa un minuto.",
    redirectFromLabel: 'Percorso di origine',
    redirectToLabel: 'Reindirizza a',
    redirectFromHint: "Deve essere un percorso che inizia con '/', senza query o spazi",
    redirectToHint: "Inserisci un URL assoluto (https://…) o un percorso di questo sito che inizia con '/'",
    addRedirect: 'Aggiungi reindirizzamento',
    updateRedirect: 'Aggiorna reindirizzamento',
    editRedirect: 'Modifica reindirizzamento',
    currentRedirects: 'Reindirizzamenti attuali',
    noRedirects: 'Nessun reindirizzamento configurato.',
    redirectPermanent: 'Permanente ({{code}})',
    redirectTemporary: 'Temporaneo ({{code}})',
    redirectAdded: 'Reindirizzamento aggiunto',
    redirectUpdated: 'Reindirizzamento aggiornato',
    redirectRemoved: 'Reindirizzamento rimosso',
  },
  aiAssistant: {
    title: 'Crea il tuo sito web con il tuo assistente IA',
    pitch: 'Usa il ChatGPT o il Claude che hai già: ti fa delle domande, crea la tua pagina e tu carichi un solo file. Provare è gratis; paghi solo quando vuoi andare online.',
    step1Title: 'Copia questa riga e incollala nel tuo assistente',
    oneLiner: 'Leggi {{url}} e aiutami a creare il mio sito web.',
    step1Description: 'Il tuo assistente legge le nostre istruzioni da quella pagina. Niente da installare, niente da collegare.',
    copy: 'Copia',
    copiedShort: 'Copiato',
    copied: 'La riga è negli appunti. Incollala nel tuo assistente.',
    copyFailed: 'Impossibile copiare. Seleziona la riga e copiala a mano.',
    step2Title: 'Rispondi alle sue domande e scarica il file index.html che ti dà',
    step2Description: 'Ti chiede a cosa serve il sito, il tuo nome, cosa offri e come contattarti, poi crea la pagina e te la mostra. Chiedi modifiche finché non ti piace, poi scarica il file.',
    step3Title: 'Crea un sito su YWT e carica quel file',
    step3Description:
      'Sotto Hosting web, crea un sito e scegli «Crealo con il tuo assistente IA» nella scheda «Modifica». Puoi vederlo in anteprima e condividere un link alla bozza subito. Per metterlo sul tuo dominio, pubblicalo con il piano Starter.',
    goToHosting: 'Hosting web',
    seePlans: 'Vedi i piani',
    tabsTitle: 'Dove incollarla',
    chatgptOpen: "Apri ChatGPT (chatgpt.com o l'app desktop) e inizia una nuova chat.",
    claudeOpen: "Apri Claude (claude.ai o l'app desktop) e inizia una nuova chat.",
    pasteAndEnter: 'Incolla la riga e premi Invio.',
    noBrowsingHint: 'Se dice che non può aprire la pagina, usa «Copia il prompt completo» qui sotto e incolla quello.',
    chatgptResult: 'La pagina finita arriva come file da scaricare. Salvala come index.html.',
    claudeResult: 'La pagina finita appare come artefatto accanto alla chat. Usa il suo pulsante di download e salvala come index.html.',
    fullPromptTitle: 'Il tuo assistente non può aprire link?',
    fullPromptDescription: 'Copia invece il prompt iniziale completo (in inglese) e incollalo nella chat. Funziona allo stesso modo.',
    copyFullPrompt: 'Copia il prompt completo',
    fullPromptCopied: 'Il prompt completo è negli appunti. Incollalo nel tuo assistente.',
    fullPromptFailed: 'Impossibile caricare il prompt. Abbiamo aperto la pagina della documentazione in una nuova scheda; copialo da lì.',
    openDocs: 'Leggilo nella documentazione',
    faqPhotosQ: 'E le foto?',
    faqPhotosA: "Il tuo assistente non vede le tue foto, quindi lascia un segnaposto dove va ciascuna. Dopo aver caricato la pagina, aggiungi le foto nell'editor, scheda «Modifica».",
    faqChangesQ: 'Come cambio qualcosa più tardi?',
    faqChangesA: 'Scarica il tuo index.html dalla scheda «Modifica», dallo al tuo assistente e digli cosa cambiare. Poi carica il nuovo file nello stesso modo.',
    faqCostQ: 'Quanto costa?',
    faqCostA: 'Creare la pagina e condividere un link alla bozza è gratis, come il tuo account YWT. Per pubblicarla su Internet, sul tuo dominio, serve il piano Starter.',
  },
  consent: {
    title: 'Cookie di analisi',
    body: 'Possiamo usare i cookie di analisi? Ci aiutano a capire cosa funziona su questo sito e cosa no.',
    accept: 'Va bene',
    decline: 'No grazie',
    settings: 'Impostazioni dei cookie',
  },
  footer: {
    productOf: '\u00e8 un prodotto di Cuspar GmbH, \u00a9 Cuspar GmbH {{year}}',
    swissMadeSoftware: 'Swiss Made Software',
  },
  admin: {
    domainSynced: '{{domain}} sincronizzato',
    domainsSynced: '{{count}} dominio/i sincronizzato/i',
    filterDomainsPlaceholder: 'Filtra per dominio o e-mail del cliente…',
    domainsShown: '{{shown}} / {{total}}',
    syncAllShown: 'Sincronizza tutti quelli mostrati ({{count}})',
    sync: 'Sincronizza',
    domains: 'Domini',
    users: 'Utenti',
    subscriptions: 'Abbonamenti hosting statico',
    user: 'Utente',
    registrar: 'Registrar',
    expires: 'Scadenza',
    autoRenew: 'Rinnovo automatico',
    ywtDns: 'YWT DNS',
    deleted: 'Eliminato',
    renewals: 'Rinnovi',
    urlForwarding: 'Reindirizzamento URL',
    rules: '{{count}} regola/e',
    staticSite: 'Sito statico',
    orders: 'Ordini',
    websites: 'Siti web',
    subscription: 'Abbonamento',
    none: 'Nessuno',
    impersonate: 'Impersona',
    deleteUser: 'Elimina account',
    deleteUserTitle: 'Eliminare l’account di {{email}}?',
    deleteUserDescription:
      'L’operazione non può essere annullata. Profilo, credenziali, contatti, metodi di pagamento salvati, carrello, ordini non pagati, siti web ({{sites}}), zone DNS e inoltri URL del cliente vengono eliminati definitivamente e il cliente viene avvisato via e-mail.',
    deleteUserSubscription: 'L’abbonamento di hosting attivo termina subito, senza rimborso.',
    deleteUserRetention: 'Gli ordini pagati ({{count}}) vengono conservati per dieci anni, come richiede il diritto svizzero.',
    deleteUserBlockedDomains: 'Questo cliente ha ancora domini registrati presso di noi. Devono prima essere trasferiti altrove o eliminati:',
    deleteUserBlockedOrder: 'Uno degli ordini del cliente è ancora in elaborazione. Riprova quando sarà completato.',
    deleteUserBlockedAdmin: 'Gli account amministratore non possono essere eliminati.',
    deleteUserConfirmLabel: 'Digita l’indirizzo e-mail del cliente per confermare',
    deleteUserSuccess: 'L’account di {{email}} è stato eliminato.',
    owner: 'Proprietario',
    tier: 'Livello',
    interval: 'Intervallo',
    start: 'Inizio',
    cancelAtEnd: 'Annulla alla fine',
    eppAdmin: 'Amministrazione EPP',
    general: 'Generale',
    auth: 'Autenticazione',
    poll: 'Sondaggio',
    statistics: 'Statistiche',
    resources: 'Risorse',
    domain: 'Dominio',
    contact: 'Contatto',
    host: 'Host',
  },
  subscription: {
    calculatingPlanChange: 'Calcolo del cambio di piano...',
    upgradeTo: 'Passa a {{tier}}',
    upgradeImmediate: 'Avrai accesso immediato a tutte le funzionalità {{tier}}.',
    planUpgrade: 'Upgrade al piano {{tier}}',
    daysUntil: '{{days}} giorni fino al {{date}}',
    prorationExplanation: 'Questa è la differenza di prezzo tra {{currentTier}} e {{newTier}} per il periodo di abbonamento rimanente.',
    whatYouGet: 'Cosa otterrai:',
    upToWebsites: 'Fino a {{count}} siti web (attualmente {{current}})',
    upToCustomDomains: 'Fino a {{count}} domini personalizzati per sito (attualmente {{current}})',
    redirectToPayment: 'Verrai reindirizzato per completare il pagamento.',
    createOrder: 'Crea ordine',
    downgradeTo: 'Passa a {{tier}}',
    downgradeAtEnd: 'Il tuo piano cambierà alla fine del periodo di fatturazione corrente.',
    cannotDowngradeYet: 'Impossibile effettuare il downgrade:',
    planChangesOn: 'Il piano cambia il <strong>{{date}}</strong>',
    continueAccess: 'Continuerai ad avere accesso a tutte le funzionalità {{tier}} fino ad allora.',
    afterDowngrade: 'Dopo il downgrade:',
    maxWebsites: 'Massimo {{count}} sito/i web',
    maxCustomDomains: 'Massimo {{count}} dominio/i personalizzato/i per sito',
    noRefund: 'Non verrà effettuato alcun rimborso. Puoi annullare questa modifica programmata in qualsiasi momento prima della fine del periodo di fatturazione.',
    scheduleDowngrade: 'Programma downgrade',
    upgradeComplete: 'Upgrade completato!',
    downgradeScheduled: 'Downgrade programmato',
    nowHaveAccess: 'Ora hai accesso a tutte le funzionalità {{tier}}. Buon utilizzo!',
    planWillChange: 'Il tuo piano cambierà a {{tier}} il {{date}}.',
    somethingWentWrong: 'Qualcosa è andato storto',
    done: 'Fatto',
    downgradeToast: 'Downgrade a {{tier}} programmato per il {{date}}',
    changingTo: 'Cambio a <strong>{{tier}}</strong> il {{date}}',
    scheduledChangeCancelled: 'Modifica programmata annullata',
    failedToCancelChange: 'Impossibile annullare la modifica programmata',
    failedToCalculate: 'Impossibile calcolare il cambio di piano',
    failedToCreateOrder: "Impossibile creare l'ordine di upgrade",
    failedToSchedule: 'Impossibile pianificare il downgrade',
    validationFailed: 'Validazione non riuscita',
    // FreePlanDialog
    freePlan: 'Piano gratuito',
    yourPlan: 'Il tuo piano',
    freeLabel: 'Gratuito',
    freePlanDescription: 'Il piano gratuito ti permette di creare e condividere una bozza. La pubblicazione la mette su Internet con il tuo dominio e richiede un piano.',
    usage: 'Utilizzo',
    websites: 'Siti web',
    customDomains: 'Domini personalizzati',
    notAvailable: 'Non disponibile',
    freePlanLimitations: 'Limitazioni del piano gratuito',
    publishNeedsPlan: 'La pubblicazione richiede un piano',
    noCustomDomain: 'Nessun dominio personalizzato',
    upgradeToUnlock: "Effettua l'upgrade per sbloccare",
    permanentPublicUrl: 'URL pubblico permanente',
    customDomainSupport: 'Supporto dominio personalizzato',
    fastSecureDelivery: 'Distribuzione veloce e sicura con HTTPS',
    viewPlansAndPricing: 'Visualizza piani e prezzi',
    // GoLiveDialog
    readyToGoLive: 'Pronto per pubblicare?',
    goLiveDescriptionWithName: 'Il piano gratuito ti permette di creare e condividere "{{name}}" come bozza. La pubblicazione la mette su Internet con il tuo dominio e richiede un piano.',
    goLiveDescription: 'Il piano gratuito ti permette di creare e condividere una bozza. La pubblicazione la mette su Internet con il tuo dominio e richiede un piano.',
    whatsIncluded: 'Cosa è incluso:',
    draftModeNotice: 'Il tuo sito è una <strong>bozza</strong>. Solo le persone a cui invii il suo link di anteprima possono vederlo. La pubblicazione lo rende pubblico.',
    // ExpiredPlanDialog
    renewPlan: 'Rinnova piano',
    expired: 'Scaduto',
    ends: 'Termina',
    expiredDescription: 'Il tuo abbonamento è scaduto. Rinnova per continuare a utilizzare i tuoi siti web.',
    expiredNotice: 'Il tuo piano {{tier}} ({{interval}}) è scaduto il {{date}}.',
    expiredWarning: "I tuoi siti web non saranno più accessibili pubblicamente a breve. Rinnova il tuo abbonamento per ripristinare l'accesso.",
    plan: 'Piano',
    billing: 'Fatturazione',
    monthly: 'Mensile',
    yearly: 'Annuale',
    expiredOn: 'Scaduto il',
    renewTierPlan: 'Rinnova piano {{tier}}',
    renewCheckoutNotice: 'Verrai reindirizzato al pagamento per completare la transazione. Il tuo abbonamento verrà esteso di {{period}} a partire da oggi.',
    oneMonth: '1 mese',
    // PlanManagementDialog
    managePlan: 'Gestisci piano',
    managePlanDescription: 'Visualizza i dettagli del tuo abbonamento e gestisci il tuo piano.',
    cancelledNotice: 'Il tuo abbonamento terminerà il <strong>{{date}}</strong>. Non ti verrà addebitato nuovamente.',
    billedInfo: 'Fatturato {{interval}} \u00b7 {{action}} il',
    planFeatures: 'Funzionalità del piano',
    websitesCount: '{{count}} sito/i web',
    customDomainsCount: '{{count}} dominio/i personalizzato/i',
    upgradeToBusiness: 'Passa a Business',
    downgradeToStarter: 'Passa a Starter',
    upgradeHint: "Effettua l'upgrade in qualsiasi momento. Paga solo la differenza di prezzo per i giorni rimanenti.",
    downgradeHint: 'Il downgrade avrà effetto alla fine del periodo di fatturazione.',
    cancelSubscription: 'Annulla abbonamento',
    cancelSubscriptionTitle: 'Annullare il tuo abbonamento?',
    cancelSubscriptionDescription:
      "Il tuo abbonamento rimarrà attivo fino al <strong>{{date}}</strong>. Dopo di che, perderai l'accesso ai tuoi siti web e domini personalizzati. Fino ad allora puoi riattivarlo qui in qualsiasi momento.",
    keepSubscription: 'Mantieni abbonamento',
    yesCancel: 'Sì, annulla',
    cancelSubscriptionSuccess: "Annullamento dell'abbonamento pianificato per il {{date}}.",
    cancelSubscriptionFailed: "Impossibile annullare l'abbonamento",
    resumeSubscription: 'Riattiva abbonamento',
    resumeSubscriptionTitle: 'Riattivare il tuo abbonamento?',
    resumeSubscriptionDescription: 'Il tuo piano {{tier}} si rinnoverà automaticamente il <strong>{{date}}</strong> e in quel momento verrà addebitato il tuo metodo di pagamento predefinito.',
    resumeSubscriptionDismiss: 'Non ora',
    resumeSubscriptionSuccess: 'Abbonamento riattivato. Si rinnoverà il {{date}}.',
  },
  home: {
    swissAccreditedRegistrar: 'Registrar accreditato svizzero',
    heroTitle: 'your web tech',
    heroSubtitle: 'Registra domini .ch/.li - veloce, semplice e pulito.',
    heroSubtitlePrice: "Domini .ch e .li a {{price}} all'anno, ogni anno.",
    sameRenewalPrice: 'Stesso prezzo a ogni rinnovo',
    freeTransfers: 'Trasferimenti gratuiti',
    comparePrices: 'Vedi e confronta i prezzi',
  },
  whois: {
    title: 'Ricerca Whois',
    subtitle: 'Supporta tutti i TLD. Minimale e veloce.',
    placeholder: 'Inserisci un nome di dominio, es. example.com',
    check: 'Verifica',
    noData: 'Nessun dato WHOIS disponibile per questo dominio.',
    disclaimer: 'La ricerca Whois non è in tempo reale e può richiedere fino a 24 ore.',
    disclaimerTld: 'A seconda del TLD, le informazioni potrebbero non essere completamente disponibili.',
    summaryFor: 'Riepilogo Whois per',
    domain: 'Dominio:',
    status: 'Stato:',
    nameServers: 'Server dei nomi:',
    created: 'Creato:',
    expires: 'Scade:',
    updated: 'Aggiornato:',
    whoisServer: 'Server WHOIS:',
    dnssec: 'DNSSEC:',
    registrar: 'Registrar',
    registrant: 'Titolare',
    administrative: 'Amministrativo',
    technical: 'Tecnico',
    billing: 'Fatturazione',
    registrarName: 'Nome:',
    registrarWebsite: 'Sito web:',
    registrarEmail: 'E-mail:',
    registrarPhone: 'Telefono:',
  },
};
